const literally = (t) => t;
export const styleTokens = literally({
    "app": {
        "font": {
            "size": "14"
        },
        "card": {
            "background": "#fffffe"
        },
        "sm": {
            "font": {
                "size": "0.875rem"
            },
            "line": {
                "height": "1.25rem"
            }
        },
        "lg": {
            "font": {
                "size": "1.125rem"
            },
            "line": {
                "height": "1.75rem"
            }
        }
    },
    "button": {
        "primary": {
            "background": "#1e1b15",
            "hover": {
                "background": "#312d25",
                "border": {
                    "color": "#1e1b15"
                },
                "color": "#fffffe"
            },
            "active": {
                "background": "#474238",
                "border": {
                    "color": "#312d25"
                },
                "color": "#fffffe"
            },
            "border": {
                "color": "#1e1b15"
            },
            "color": "#fffffe",
            "focus": {
                "ring": {
                    "color": "#1e1b15"
                }
            }
        },
        "secondary": {
            "background": "#fffffe",
            "hover": {
                "background": "#e4e2dd",
                "border": {
                    "color": "#e4e2dd"
                },
                "color": "#1e1b15"
            },
            "active": {
                "background": "#fffbe6",
                "border": {
                    "color": "#c1ac00"
                },
                "color": "#0c0800"
            },
            "border": {
                "color": "#f4f2ee"
            },
            "color": "#0c0800",
            "focus": {
                "ring": {
                    "color": "#868074"
                }
            }
        },
        "info": {
            "background": "#1e9bd0",
            "hover": {
                "background": "#48b6ec",
                "border": {
                    "color": "#1e9bd0"
                },
                "color": "#ffffff"
            },
            "active": {
                "background": "#7fd0ff",
                "border": {
                    "color": "#48b6ec"
                },
                "color": "#ffffff"
            },
            "border": {
                "color": "#1e9bd0"
            },
            "color": "#ffffff",
            "focus": {
                "ring": {
                    "color": "#1e9bd0"
                }
            }
        },
        "success": {
            "background": "#22c55e",
            "hover": {
                "background": "#16a34a",
                "border": {
                    "color": "#22c55e"
                },
                "color": "#ffffff"
            },
            "active": {
                "background": "#15803d",
                "border": {
                    "color": "#16a34a"
                },
                "color": "#ffffff"
            },
            "border": {
                "color": "#22c55e"
            },
            "color": "#ffffff",
            "focus": {
                "ring": {
                    "color": "#22c55e"
                }
            }
        },
        "warn": {
            "background": "#f97316",
            "hover": {
                "background": "#ea580c",
                "border": {
                    "color": "#ea580c"
                },
                "color": "#ffffff"
            },
            "active": {
                "background": "#c2410c",
                "border": {
                    "color": "#ea580c"
                },
                "color": "#ffffff"
            },
            "border": {
                "color": "#f97316"
            },
            "color": "#ffffff",
            "focus": {
                "ring": {
                    "color": "#f97316"
                }
            }
        },
        "help": {
            "background": "#e68cd9",
            "hover": {
                "background": "#ffabf0",
                "border": {
                    "color": "#ffabf0"
                },
                "color": "#ffffff"
            },
            "active": {
                "background": "#ffd7f4",
                "border": {
                    "color": "#ffd7f4"
                },
                "color": "#ffffff"
            },
            "border": {
                "color": "#e68cd9"
            },
            "color": "#ffffff",
            "focus": {
                "ring": {
                    "color": "#e68cd9"
                }
            }
        },
        "danger": {
            "background": "#900b13",
            "hover": {
                "background": "#b32927",
                "border": {
                    "color": "#b32927"
                },
                "color": "#ffffff"
            },
            "active": {
                "background": "#d5423c",
                "border": {
                    "color": "#b32927"
                },
                "color": "#ffffff"
            },
            "border": {
                "color": "#900b13"
            },
            "color": "#ffffff",
            "focus": {
                "ring": {
                    "color": "#900b13"
                }
            }
        },
        "contrast": {
            "background": "#1e1b15",
            "hover": {
                "background": "#312d25",
                "border": {
                    "color": "#1e1b15"
                },
                "color": "#fffffe"
            },
            "active": {
                "background": "#474238",
                "border": {
                    "color": "#312d25"
                },
                "color": "#fffffe"
            },
            "border": {
                "color": "#1e1b15"
            },
            "color": "#fffffe",
            "focus": {
                "ring": {
                    "color": "#1e1b15"
                }
            }
        },
        "outlined": {
            "primary": {
                "hover": {
                    "background": "#faf9f7"
                },
                "active": {
                    "background": "#f4f2ee"
                },
                "border": {
                    "color": "#e4e2dd"
                },
                "color": "#1e1b15"
            },
            "secondary": {
                "hover": {
                    "background": "#faf9f7"
                },
                "active": {
                    "background": "#f4f2ee"
                },
                "border": {
                    "color": "#e4e2dd"
                },
                "color": "#99948a"
            },
            "success": {
                "hover": {
                    "background": "#f0fdf4"
                },
                "active": {
                    "background": "#dcfce7"
                },
                "border": {
                    "color": "#bbf7d0"
                },
                "color": "#22c55e"
            },
            "info": {
                "hover": {
                    "background": "#e4f3ff"
                },
                "active": {
                    "background": "#c5e7ff"
                },
                "border": {
                    "color": "#7fd0ff"
                },
                "color": "#1e9bd0"
            },
            "warn": {
                "hover": {
                    "background": "#fff7ed"
                },
                "active": {
                    "background": "#ffedd5"
                },
                "border": {
                    "color": "#fed7aa"
                },
                "color": "#f97316"
            },
            "help": {
                "hover": {
                    "background": "#ffebf7"
                },
                "active": {
                    "background": "#ffd7f4"
                },
                "border": {
                    "color": "#ffabf0"
                },
                "color": "#e68cd9"
            },
            "danger": {
                "hover": {
                    "background": "#ffedeb"
                },
                "active": {
                    "background": "#ffdad6"
                },
                "border": {
                    "color": "#b32927"
                },
                "color": "#900b13"
            },
            "contrast": {
                "hover": {
                    "background": "#faf9f7"
                },
                "active": {
                    "background": "#f4f2ee"
                },
                "border": {
                    "color": "#686257"
                },
                "color": "#1e1b15"
            },
            "plain": {
                "hover": {
                    "background": "#faf9f7"
                },
                "active": {
                    "background": "#f4f2ee"
                },
                "border": {
                    "color": "#e4e2dd"
                },
                "color": "#0c0800"
            }
        },
        "text": {
            "primary": {
                "hover": {
                    "background": "#faf9f7"
                },
                "active": {
                    "background": "#f4f2ee"
                },
                "color": "#1e1b15"
            },
            "secondary": {
                "hover": {
                    "background": "#faf9f7"
                },
                "active": {
                    "background": "#f4f2ee"
                },
                "color": "#99948a"
            },
            "success": {
                "hover": {
                    "background": "#f0fdf4"
                },
                "active": {
                    "background": "#dcfce7"
                },
                "color": "#22c55e"
            },
            "info": {
                "hover": {
                    "background": "#e4f3ff"
                },
                "active": {
                    "background": "#c5e7ff"
                },
                "color": "#1e9bd0"
            },
            "warn": {
                "hover": {
                    "background": "#fff7ed"
                },
                "active": {
                    "background": "#ffedd5"
                },
                "color": "#f97316"
            },
            "help": {
                "hover": {
                    "background": "#ffebf7"
                },
                "active": {
                    "background": "#ffd7f4"
                },
                "color": "#e68cd9"
            },
            "danger": {
                "hover": {
                    "background": "#ffedeb"
                },
                "active": {
                    "background": "#ffdad6"
                },
                "color": "#900b13"
            },
            "plain": {
                "hover": {
                    "background": "#faf9f7"
                },
                "active": {
                    "background": "#f4f2ee"
                },
                "color": "#0c0800"
            },
            "contrast": {
                "hover": {
                    "background": "#faf9f7"
                },
                "active": {
                    "background": "#f4f2ee"
                },
                "color": "#1e1b15"
            }
        },
        "link": {
            "color": "#1e1b15",
            "hover": {
                "color": "#1e1b15"
            },
            "active": {
                "color": "#1e1b15"
            }
        },
        "border": {
            "radius": "6px"
        },
        "rounded": {
            "border": {
                "radius": "2rem"
            }
        },
        "gap": "0.5rem",
        "padding": {
            "x": "0.75rem",
            "y": "0.5rem"
        },
        "icon": {
            "only": {
                "width": "2.5rem"
            }
        },
        "sm": {
            "font": {
                "size": "0.875rem"
            },
            "padding": {
                "x": "0.625rem",
                "y": "0.375rem"
            }
        },
        "lg": {
            "font": {
                "size": "1.125rem"
            },
            "padding": {
                "x": "0.875rem",
                "y": "0.625rem"
            }
        },
        "label": {
            "font": {
                "weight": "500"
            }
        },
        "focus": {
            "ring": {
                "width": "1",
                "offset": "2",
                "style": "solid"
            }
        },
        "raised": {
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "3",
                    "blur": "8",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0.05)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "0",
                    "blur": "1",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0.2)",
                    "type": "dropShadow"
                }
            }
        }
    },
    "toggleswitch": {
        "background": "#cfccc5",
        "hover": {
            "background": "#b6b2aa",
            "border": {
                "color": "rgba(0, 0, 0, 0)"
            }
        },
        "checked": {
            "background": "#1e1b15",
            "hover": {
                "background": "#312d25",
                "border": {
                    "color": "rgba(0, 0, 0, 0)"
                }
            },
            "border": {
                "color": "rgba(0, 0, 0, 0)"
            }
        },
        "handle": {
            "background": "#fffffe",
            "hover": {
                "background": "#fffffe",
                "color": "#0c0800"
            },
            "checked": {
                "background": "#fffffe",
                "hover": {
                    "background": "#fffffe",
                    "color": "#312d25"
                },
                "color": "#1e1b15"
            },
            "color": "#686257",
            "disabled": {
                "background": "#99948a"
            },
            "border": {
                "radius": "0.5rem"
            },
            "size": "1rem"
        },
        "disabled": {
            "background": "#e4e2dd"
        },
        "width": "2.5rem",
        "height": "1.5rem",
        "border": {
            "radius": "30px",
            "width": "1px",
            "color": "rgba(0, 0, 0, 0)"
        },
        "gap": "0.25rem",
        "invalid": {
            "border": {
                "color": "#900b13"
            }
        },
        "focus": {
            "ring": {
                "width": "1",
                "style": "solid",
                "color": "#1e1b15",
                "offset": "2",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "autocomplete": {
        "dropdown": {
            "background": "#f4f2ee",
            "hover": {
                "background": "#e4e2dd",
                "color": "#686257",
                "border": {
                    "color": "#f4f2ee"
                }
            },
            "active": {
                "background": "#cfccc5",
                "color": "#474238",
                "border": {
                    "color": "#f4f2ee"
                }
            },
            "color": "#868074",
            "width": "2.5rem",
            "border": {
                "color": "#f4f2ee",
                "radius": "6px"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "2",
                    "style": "solid",
                    "color": "#1e1b15",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            },
            "sm": {
                "width": "2rem"
            },
            "lg": {
                "width": "3rem"
            }
        },
        "chip": {
            "focus": {
                "background": "#e4e2dd"
            },
            "color": "#474238",
            "border": {
                "radius": "4px"
            }
        },
        "background": "#fffffe",
        "disabled": {
            "background": "#e4e2dd",
            "color": "#99948a"
        },
        "filled": {
            "background": "#faf9f7",
            "focus": {
                "background": "#faf9f7"
            },
            "hover": {
                "background": "#faf9f7"
            }
        },
        "border": {
            "color": "#f4f2ee",
            "radius": "6px"
        },
        "hover": {
            "border": {
                "color": "#b6b2aa"
            }
        },
        "focus": {
            "border": {
                "color": "#1e1b15"
            },
            "ring": {
                "width": "0",
                "style": "none",
                "color": "rgba(0, 0, 0, 0)",
                "offset": "0",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            },
            "placeholder": {
                "color": "#b32927"
            }
        },
        "color": "#1e1b15",
        "placeholder": {
            "color": "#686257"
        },
        "padding": {
            "x": "0.75rem",
            "y": "0.5rem"
        },
        "overlay": {
            "background": "rgba(255, 255, 255, 0.9)",
            "border": {
                "color": "#f4f2ee",
                "radius": "8px"
            },
            "color": "#0c0800",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "list": {
            "padding": "0.25rem 0.25rem",
            "gap": "2px"
        },
        "option": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "selected": {
                "background": "#faf9f7",
                "focus": {
                    "background": "#f4f2ee",
                    "color": "#474238"
                },
                "color": "#686257"
            },
            "color": "#0c0800",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "group": {
                "background": "rgba(0, 0, 0, 0)",
                "color": "#686257",
                "font": {
                    "weight": "600"
                },
                "padding": "0.5rem 0.75rem"
            }
        },
        "empty": {
            "message": {
                "padding": "0.5rem 0.75rem"
            }
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "badge": {
        "primary": {
            "background": "#1e1b15",
            "color": "#fffffe"
        },
        "secondary": {
            "background": "#f4f2ee",
            "color": "#868074"
        },
        "success": {
            "background": "#22c55e",
            "color": "#fffffe"
        },
        "info": {
            "background": "#1e9bd0",
            "color": "#fffffe"
        },
        "warn": {
            "background": "#f97316",
            "color": "#fffffe"
        },
        "danger": {
            "background": "#900b13",
            "color": "#fffffe"
        },
        "contrast": {
            "background": "#1e1b15",
            "color": "#fffffe"
        },
        "border": {
            "radius": "6px"
        },
        "padding": "0 0.5rem",
        "font": {
            "size": "0.75rem",
            "weight": "700"
        },
        "min": {
            "width": "1.25rem"
        },
        "height": "1.25rem",
        "dot": {
            "size": "0.5rem"
        },
        "sm": {
            "font": {
                "size": "0.625rem"
            },
            "min": {
                "width": "1rem"
            },
            "height": "1rem"
        },
        "lg": {
            "font": {
                "size": "0.875rem"
            },
            "min": {
                "width": "1.5rem"
            },
            "height": "1.5rem"
        },
        "xl": {
            "font": {
                "size": "1rem"
            },
            "min": {
                "width": "1.75rem"
            },
            "height": "1.75rem"
        }
    },
    "chip": {
        "background": "#f4f2ee",
        "color": "#474238",
        "icon": {
            "color": "#474238",
            "size": "1rem"
        },
        "remove": {
            "icon": {
                "color": "#474238",
                "focus": {
                    "ring": {
                        "width": "1",
                        "style": "solid",
                        "offset": "2",
                        "color": "#1e1b15"
                    }
                },
                "size": "1rem",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "border": {
            "radius": "16px"
        },
        "padding": {
            "x": "0.75rem",
            "y": "0.5rem"
        },
        "gap": "0.5rem",
        "image": {
            "width": "2rem",
            "height": "2rem"
        }
    },
    "tag": {
        "primary": {
            "background": "#f4f2ee",
            "color": "#686257"
        },
        "secondary": {
            "background": "#f4f2ee",
            "color": "#1e1b15"
        },
        "success": {
            "background": "#dcfce7",
            "color": "#15803d"
        },
        "info": {
            "background": "#c5e7ff",
            "color": "#004c6a"
        },
        "warn": {
            "background": "#ffedd5",
            "color": "#c2410c"
        },
        "danger": {
            "background": "#ffdad6",
            "color": "#900b13"
        },
        "contrast": {
            "background": "#1e1b15",
            "color": "#fffffe"
        },
        "draft": {
            "background": "#cfccc5",
            "color": "#1e1b15"
        },
        "submitted": {
            "background": "#fff2b0",
            "color": "#201c00"
        },
        "pending": {
            "background": "#ffb2b8",
            "color": "#ffffff"
        },
        "surveying": {
            "background": "#ffd7f4",
            "color": "#380037"
        },
        "complete": {
            "background": "#c5e7ff",
            "color": "#001e2d"
        },
        "demo": {
            "background": "#1e9bd0",
            "color": "#ffffff"
        },
        "font": {
            "size": "0.875rem",
            "weight": "700"
        },
        "padding": "0.25rem 0.5rem",
        "gap": "0.25rem",
        "border": {
            "radius": "6px"
        },
        "rounded": {
            "border": {
                "radius": "12px"
            }
        },
        "icon": {
            "size": "0.75rem"
        }
    },
    "skeleton": {
        "background": "#e4e2dd",
        "border": {
            "radius": "6px"
        }
    },
    "datepicker": {
        "dropdown": {
            "background": "#f4f2ee",
            "hover": {
                "background": "#e4e2dd",
                "color": "#686257",
                "border": {
                    "color": "#f4f2ee"
                }
            },
            "active": {
                "background": "#cfccc5",
                "color": "#474238",
                "border": {
                    "color": "#f4f2ee"
                }
            },
            "color": "#868074",
            "width": "2.5rem",
            "border": {
                "color": "#f4f2ee",
                "radius": "6px"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "style": "solid",
                    "color": "#1e1b15",
                    "offset": "2",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            },
            "sm": {
                "width": "2rem"
            },
            "lg": {
                "width": "3rem"
            }
        },
        "today": {
            "background": "#e4e2dd",
            "color": "#312d25"
        },
        "panel": {
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "radius": "6px"
            },
            "color": "#0c0800",
            "padding": "0.75rem",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "header": {
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd"
            },
            "color": "#0c0800",
            "padding": "0 0 0.5rem 0"
        },
        "title": {
            "gap": "0.5rem",
            "font": {
                "weight": "500"
            }
        },
        "input": {
            "icon": {
                "color": "#1e1b15"
            }
        },
        "select": {
            "month": {
                "hover": {
                    "background": "#faf9f7",
                    "color": "#1e1b15"
                },
                "color": "#0c0800",
                "padding": "0.25rem 0.5rem",
                "border": {
                    "radius": "6px"
                }
            },
            "year": {
                "hover": {
                    "background": "#faf9f7",
                    "color": "#1e1b15"
                },
                "color": "#0c0800",
                "padding": "0.25rem 0.5rem",
                "border": {
                    "radius": "6px"
                }
            }
        },
        "group": {
            "border": {
                "color": "#e4e2dd"
            },
            "gap": "0.75rem"
        },
        "day": {
            "view": {
                "margin": "0.5rem 0 0 0"
            }
        },
        "week": {
            "day": {
                "padding": "0.25rem",
                "font": {
                    "weight": "500"
                },
                "color": "#0c0800"
            }
        },
        "date": {
            "hover": {
                "background": "#faf9f7",
                "color": "#1e1b15"
            },
            "selected": {
                "background": "#1e1b15",
                "color": "#fffffe"
            },
            "range": {
                "selected": {
                    "background": "#faf9f7",
                    "color": "#686257"
                }
            },
            "color": "#0c0800",
            "width": "2rem",
            "height": "2rem",
            "border": {
                "radius": "1rem"
            },
            "padding": "0.25rem",
            "focus": {
                "ring": {
                    "width": "1",
                    "style": "solid",
                    "color": "#1e1b15",
                    "offset": "2",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        },
        "month": {
            "view": {
                "margin": "0.5rem 0 0 0"
            },
            "border": {
                "radius": "6px"
            },
            "padding": "0.375rem"
        },
        "year": {
            "view": {
                "margin": "0.5rem 0 0 0"
            },
            "border": {
                "radius": "6px"
            },
            "padding": "0.375rem"
        },
        "buttonbar": {
            "padding": "0.5rem 0 0 0",
            "border": {
                "color": "#e4e2dd"
            }
        },
        "time": {
            "picker": {
                "padding": "0.5rem 0 0 0",
                "border": {
                    "color": "#e4e2dd"
                },
                "gap": "0.5rem",
                "button": {
                    "gap": "0.25rem"
                }
            }
        }
    },
    "colorpicker": {
        "panel": {
            "background": "#474238",
            "border": {
                "color": "#312d25",
                "radius": "6px"
            },
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "handle": {
            "color": "#fffffe"
        },
        "preview": {
            "width": "1.5rem",
            "height": "1.5rem",
            "border": {
                "radius": "6px"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "style": "solid",
                    "color": "#1e1b15",
                    "offset": "2",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        }
    },
    "inputnumber": {
        "button": {
            "background": "rgba(0, 0, 0, 0)",
            "hover": {
                "background": "#f4f2ee",
                "border": {
                    "color": "#f4f2ee"
                },
                "color": "#99948a"
            },
            "active": {
                "background": "#e4e2dd",
                "border": {
                    "color": "#f4f2ee"
                },
                "color": "#868074"
            },
            "border": {
                "color": "#f4f2ee",
                "radius": "6px"
            },
            "color": "#b6b2aa",
            "width": "2.5rem",
            "vertical": {
                "padding": "0.5rem"
            }
        }
    },
    "listbox": {
        "option": {
            "striped": {
                "background": "#faf9f7"
            },
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "selected": {
                "background": "#faf9f7",
                "focus": {
                    "background": "#f4f2ee",
                    "color": "#474238"
                },
                "color": "#686257"
            },
            "color": "#0c0800",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "group": {
                "background": "rgba(0, 0, 0, 0)",
                "color": "#686257",
                "font": {
                    "weight": "600"
                },
                "padding": "0.5rem 0.75rem"
            }
        },
        "background": "#fffffe",
        "disabled": {
            "background": "#e4e2dd",
            "color": "#99948a"
        },
        "border": {
            "color": "#f4f2ee",
            "radius": "8px"
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            }
        },
        "color": "#1e1b15",
        "focus": {
            "ring": {
                "color": "rgba(0, 0, 0, 0)",
                "width": "0px",
                "offset": "0px",
                "style": "solid"
            },
            "border": {
                "color": "rgba(0, 0, 0, 0)"
            }
        },
        "hover": {
            "border": {
                "color": "rgba(0, 0, 0, 0)"
            }
        },
        "list": {
            "padding": "0.25rem 0.25rem",
            "gap": "2px",
            "header": {
                "padding": "0.5rem 0.75rem 0.25rem 0.75rem"
            }
        },
        "checkmark": {
            "color": "#0c0800",
            "gutter": {
                "start": "-0.375rem",
                "end": "0.375rem"
            }
        },
        "empty": {
            "message": {
                "padding": "0.5rem 0.75rem"
            }
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "password": {
        "strength": {
            "week": {
                "background": "#d5423c"
            },
            "medium": {
                "background": "#f59e0b"
            },
            "strong": {
                "background": "#22c55e"
            }
        },
        "meter": {
            "background": "#e4e2dd",
            "border": {
                "radius": "6px"
            },
            "height": "0.75rem"
        },
        "icon": {
            "color": "#1e1b15"
        },
        "overlay": {
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "radius": "6px"
            },
            "color": "#0c0800",
            "padding": "0.75rem",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "content": {
            "gap": "0.5rem"
        }
    },
    "slider": {
        "handle": {
            "content": {
                "background": "#fffffe",
                "hover": {
                    "background": "#fffffe"
                },
                "width": "16px",
                "height": "16px",
                "border": {
                    "radius": "8px"
                },
                "shadow": {
                    "1": {
                        "x": "0",
                        "y": "0.5",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0.08)",
                        "type": "dropShadow"
                    },
                    "2": {
                        "x": "0",
                        "y": "1",
                        "blur": "1",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0.14)",
                        "type": "dropShadow"
                    }
                }
            },
            "width": "20px",
            "height": "20px",
            "border": {
                "radius": "15px"
            },
            "background": "#e4e2dd",
            "hover": {
                "background": "#e4e2dd"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "2",
                    "style": "solid",
                    "color": "#1e1b15",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        },
        "track": {
            "background": "#e4e2dd",
            "border": {
                "radius": "6px"
            },
            "size": "3px"
        },
        "range": {
            "background": "#1e1b15"
        }
    },
    "togglebutton": {
        "background": "rgba(0, 0, 0, 0)",
        "checked": {
            "background": "rgba(0, 0, 0, 0)",
            "color": "#0c0800",
            "border": {
                "color": "rgba(0, 0, 0, 0)"
            }
        },
        "hover": {
            "background": "rgba(0, 0, 0, 0)",
            "color": "#1e1b15"
        },
        "border": {
            "color": "rgba(0, 0, 0, 0)",
            "radius": "6px"
        },
        "color": "#686257",
        "content": {
            "checked": {
                "background": "#fffffe",
                "shadow": {
                    "1": {
                        "x": "0",
                        "y": "3",
                        "blur": "8",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0.05)",
                        "type": "dropShadow"
                    },
                    "2": {
                        "x": "0",
                        "y": "0",
                        "blur": "1",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0.3)",
                        "type": "dropShadow"
                    }
                }
            },
            "left": "0.25rem",
            "top": "0.25rem",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "1",
                    "blur": "2",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0.02)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "1",
                    "blur": "2",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0.04)",
                    "type": "dropShadow"
                }
            }
        },
        "icon": {
            "color": "#686257",
            "hover": {
                "color": "#1e1b15"
            },
            "checked": {
                "color": "#0c0800"
            },
            "disabled": {
                "color": "#99948a"
            }
        },
        "gap": "0.5rem",
        "font": {
            "weight": "500"
        },
        "disabled": {
            "background": "rgba(0, 0, 0, 0)",
            "border": {
                "color": "rgba(0, 0, 0, 0)"
            },
            "color": "#99948a"
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            }
        },
        "focus": {
            "ring": {
                "width": "1",
                "offset": "2",
                "style": "solid",
                "color": "#1e1b15",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "padding": {
            "x": "1rem",
            "y": "0.5rem"
        },
        "sm": {
            "font": {
                "size": "0.875rem"
            },
            "padding": {
                "x": "0.75rem",
                "y": "0.375rem"
            }
        },
        "lg": {
            "font": {
                "size": "1.125rem"
            },
            "padding": {
                "x": "1.25rem",
                "y": "0.625rem"
            }
        }
    },
    "selectbutton": {
        "invalid": {
            "border": {
                "color": "#680007"
            }
        },
        "background": "#f4f2ee",
        "border": {
            "radius": "8px"
        }
    },
    "scrollpanel": {
        "bar": {
            "background": "#f4f2ee",
            "size": "9px",
            "border": {
                "radius": "4px"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "2",
                    "style": "solid",
                    "color": "#1e1b15",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        }
    },
    "tooltip": {
        "background": "#fffffe",
        "color": "#0c0800",
        "border": {
            "color": "#f4f2ee",
            "radius": "6px"
        },
        "max": {
            "width": "12.5rem"
        },
        "gutter": "0.25rem",
        "padding": "0.25rem 0.5rem",
        "shadow": {
            "1": {
                "x": "0",
                "y": "3",
                "blur": "8",
                "spread": "1",
                "color": "rgba(0, 0, 0, 0.15)",
                "type": "dropShadow"
            },
            "2": {
                "x": "0",
                "y": "0",
                "blur": "1",
                "spread": "0",
                "color": "rgba(0, 0, 0, 0.2)",
                "type": "dropShadow"
            }
        }
    },
    "datatable": {
        "border": {
            "color": "#e4e2dd"
        },
        "row": {
            "striped": {
                "background": "#faf9f7"
            },
            "background": "#fffffe",
            "hover": {
                "background": "#faf9f7",
                "color": "#1e1b15"
            },
            "selected": {
                "background": "#faf9f7",
                "color": "#686257"
            },
            "color": "#0c0800",
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "-1px",
                    "color": "#1e1b15",
                    "style": "solid",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            },
            "toggle": {
                "button": {
                    "hover": {
                        "background": "#faf9f7",
                        "color": "#0c0800"
                    },
                    "selected": {
                        "hover": {
                            "background": "#fffffe",
                            "color": "#1e1b15"
                        }
                    },
                    "color": "#686257",
                    "size": "1.75rem",
                    "border": {
                        "radius": "0.875rem"
                    },
                    "focus": {
                        "ring": {
                            "width": "1",
                            "style": "solid",
                            "offset": "2",
                            "color": "#1e1b15",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            }
        },
        "body": {
            "cell": {
                "selected": {
                    "border": {
                        "color": "#f4f2ee"
                    }
                },
                "border": {
                    "color": "#e4e2dd"
                },
                "padding": "0.75rem 1rem"
            }
        },
        "header": {
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "width": "1px"
            },
            "color": "#0c0800",
            "padding": "0.75rem 1rem",
            "cell": {
                "background": "#fffffe",
                "hover": {
                    "background": "#faf9f7",
                    "color": "#1e1b15"
                },
                "selected": {
                    "background": "#faf9f7",
                    "color": "#686257"
                },
                "border": {
                    "color": "#e4e2dd"
                },
                "color": "#0c0800",
                "gap": "0.5rem",
                "padding": "0.75rem 1rem",
                "focus": {
                    "ring": {
                        "width": "1",
                        "offset": "-1px",
                        "style": "solid",
                        "color": "#1e1b15",
                        "shadow": {
                            "x": "0",
                            "y": "0",
                            "blur": "0",
                            "spread": "0",
                            "color": "rgba(0, 0, 0, 0)",
                            "type": "dropShadow"
                        }
                    }
                }
            }
        },
        "column": {
            "title": {
                "font": {
                    "weight": "500"
                }
            },
            "footer": {
                "font": {
                    "weight": "600"
                }
            },
            "resizer": {
                "width": "0.5rem"
            }
        },
        "footer": {
            "cell": {
                "background": "#fffffe",
                "border": {
                    "color": "#e4e2dd"
                },
                "color": "#0c0800",
                "padding": "0.75rem 1rem"
            },
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "width": "1px"
            },
            "color": "#0c0800",
            "padding": "0.75rem 1rem"
        },
        "drop": {
            "point": {
                "color": "#1e1b15"
            }
        },
        "resize": {
            "indicator": {
                "width": "1px",
                "color": "#1e1b15"
            }
        },
        "sort": {
            "icon": {
                "color": "#686257",
                "hover": {
                    "color": "#686257"
                },
                "size": "0.875rem"
            }
        },
        "loading": {
            "icon": {
                "size": "2rem"
            }
        },
        "filter": {
            "inline": {
                "gap": "0.5rem"
            },
            "overlay": {
                "select": {
                    "background": "rgba(255, 255, 255, 0.9)",
                    "border": {
                        "color": "#f4f2ee",
                        "radius": "8px"
                    },
                    "color": "#0c0800",
                    "shadow": {
                        "1": {
                            "x": "0",
                            "y": "4",
                            "blur": "6",
                            "spread": "-1",
                            "color": "rgba(0, 0, 0, 0.1)",
                            "type": "dropShadow"
                        },
                        "2": {
                            "x": "0",
                            "y": "2",
                            "blur": "4",
                            "spread": "-2",
                            "color": "rgba(0, 0, 0, 0.1)",
                            "type": "dropShadow"
                        }
                    }
                },
                "popover": {
                    "background": "#fffffe",
                    "border": {
                        "color": "#e4e2dd",
                        "radius": "6px"
                    },
                    "color": "#0c0800",
                    "padding": "0.75rem",
                    "gap": "0.5rem",
                    "shadow": {
                        "1": {
                            "x": "0",
                            "y": "4",
                            "blur": "6",
                            "spread": "-1",
                            "color": "rgba(0, 0, 0, 0.1)",
                            "type": "dropShadow"
                        },
                        "2": {
                            "x": "0",
                            "y": "2",
                            "blur": "4",
                            "spread": "-2",
                            "color": "rgba(0, 0, 0, 0.1)",
                            "type": "dropShadow"
                        }
                    }
                }
            },
            "rule": {
                "border": {
                    "color": "#e4e2dd"
                }
            },
            "constraint": {
                "list": {
                    "padding": "0.25rem 0.25rem",
                    "gap": "2px"
                },
                "focus": {
                    "background": "#f4f2ee",
                    "color": "#1e1b15"
                },
                "selected": {
                    "background": "#faf9f7",
                    "focus": {
                        "background": "#f4f2ee",
                        "color": "#474238"
                    },
                    "color": "#686257"
                },
                "color": "#0c0800",
                "separator": {
                    "border": {
                        "color": "#e4e2dd"
                    }
                },
                "padding": "0.5rem 0.75rem",
                "border": {
                    "radius": "4px"
                }
            }
        },
        "paginator": {
            "top": {
                "border": {
                    "color": "#e4e2dd",
                    "width": "1"
                }
            },
            "bottom": {
                "border": {
                    "color": "#e4e2dd",
                    "width": "1"
                }
            }
        }
    },
    "carousel": {
        "indicator": {
            "background": "#e4e2dd",
            "hover": {
                "background": "#cfccc5"
            },
            "active": {
                "background": "#1e1b15"
            },
            "list": {
                "padding": "1rem",
                "gap": "0.5rem"
            },
            "width": "2rem",
            "height": "0.5rem",
            "border": {
                "radius": "6px"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "2",
                    "style": "solid",
                    "color": "#1e1b15",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        },
        "content": {
            "gap": "0.25rem"
        }
    },
    "treetable": {
        "border": {
            "color": "#e4e2dd"
        },
        "body": {
            "cell": {
                "selected": {
                    "border": {
                        "color": "#f4f2ee"
                    }
                },
                "border": {
                    "color": "#e4e2dd"
                },
                "padding": "0.75rem 1rem",
                "gap": "0.5rem"
            }
        },
        "header": {
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "width": "1px"
            },
            "color": "#0c0800",
            "padding": "0.75rem 1rem",
            "cell": {
                "background": "#fffffe",
                "hover": {
                    "background": "#faf9f7",
                    "color": "#1e1b15"
                },
                "selected": {
                    "background": "#faf9f7",
                    "color": "#686257"
                },
                "border": {
                    "color": "#e4e2dd"
                },
                "color": "#0c0800",
                "gap": "0.5rem",
                "padding": "0.75rem 1rem",
                "focus": {
                    "ring": {
                        "width": "1",
                        "offset": "-1px",
                        "style": "solid",
                        "color": "#1e1b15",
                        "shadow": {
                            "x": "0",
                            "y": "0",
                            "blur": "0",
                            "spread": "0",
                            "color": "rgba(0, 0, 0, 0)",
                            "type": "dropShadow"
                        }
                    }
                }
            }
        },
        "column": {
            "title": {
                "font": {
                    "weight": "600"
                }
            },
            "footer": {
                "font": {
                    "weight": "600"
                }
            },
            "resizer": {
                "width": "0.5rem"
            }
        },
        "row": {
            "background": "#fffffe",
            "hover": {
                "background": "#faf9f7",
                "color": "#1e1b15"
            },
            "selected": {
                "background": "#faf9f7",
                "color": "#686257"
            },
            "color": "#0c0800",
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "-1px",
                    "color": "#1e1b15",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        },
        "footer": {
            "cell": {
                "background": "#fffffe",
                "border": {
                    "color": "#e4e2dd"
                },
                "color": "#0c0800",
                "padding": "0.75rem 1rem"
            },
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "width": "1px"
            },
            "color": "#0c0800",
            "padding": "0.75rem 1rem"
        },
        "resize": {
            "indicator": {
                "width": "1px",
                "color": "#1e1b15"
            }
        },
        "sort": {
            "icon": {
                "color": "#686257",
                "hover": {
                    "color": "#686257"
                },
                "size": "0.875rem"
            }
        },
        "loading": {
            "icon": {
                "size": "2rem"
            }
        },
        "node": {
            "toggle": {
                "button": {
                    "hover": {
                        "background": "#faf9f7",
                        "color": "#0c0800"
                    },
                    "selected": {
                        "hover": {
                            "background": "#fffffe",
                            "color": "#1e1b15"
                        }
                    },
                    "color": "#686257",
                    "size": "1.75rem",
                    "border": {
                        "radius": "0.875rem"
                    },
                    "focus": {
                        "ring": {
                            "width": "1",
                            "offset": "2",
                            "style": "solid",
                            "color": "#1e1b15",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            }
        },
        "paginator": {
            "top": {
                "border": {
                    "color": "#e4e2dd",
                    "width": "1px"
                }
            },
            "bottom": {
                "border": {
                    "width": "1px",
                    "color": "#e4e2dd"
                }
            }
        }
    },
    "message": {
        "info": {
            "background": "rgb(89.412% 88.627% 86.667% / 0.95)",
            "border": {
                "color": "#e4e2dd"
            },
            "color": "#312d25",
            "close": {
                "button": {
                    "hover": {
                        "background": "#e4e2dd"
                    },
                    "focus": {
                        "ring": {
                            "color": "#868074",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "outlined": {
                "color": "#99948a",
                "border": {
                    "color": "#99948a"
                }
            },
            "simple": {
                "color": "#99948a"
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(4, 5, 6, 0.04)",
                "type": "dropShadow"
            }
        },
        "success": {
            "background": "rgb(94.118% 99.216% 95.686% / 0.95)",
            "border": {
                "color": "#bbf7d0"
            },
            "color": "#166534",
            "close": {
                "button": {
                    "hover": {
                        "background": "#dcfce7"
                    },
                    "focus": {
                        "ring": {
                            "color": "#166534",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "outlined": {
                "color": "#166534",
                "border": {
                    "color": "#166534"
                }
            },
            "simple": {
                "color": "#166534"
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(1, 8, 4, 0.04)",
                "type": "dropShadow"
            }
        },
        "warn": {
            "background": "rgb(99.608% 98.824% 90.98% / 0.95)",
            "border": {
                "color": "#fef08a"
            },
            "close": {
                "button": {
                    "hover": {
                        "background": "#fef9c3"
                    },
                    "focus": {
                        "ring": {
                            "color": "#ca8a04",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "color": "#ca8a04",
            "outlined": {
                "color": "#ca8a04",
                "border": {
                    "color": "#ca8a04"
                }
            },
            "simple": {
                "color": "#ca8a04"
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(9, 7, 0, 0.04)",
                "type": "dropShadow"
            }
        },
        "error": {
            "background": "rgb(100% 92.941% 92.157% / 0.95)",
            "border": {
                "color": "#ffb4ac"
            },
            "color": "#b32927",
            "close": {
                "button": {
                    "hover": {
                        "background": "#ffdad6"
                    },
                    "focus": {
                        "ring": {
                            "color": "#b32927",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "outlined": {
                "color": "#b32927",
                "border": {
                    "color": "#b32927"
                }
            },
            "simple": {
                "color": "#b32927"
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(10, 3, 3, 0.04)",
                "type": "dropShadow"
            }
        },
        "secondary": {
            "background": "#f4f2ee",
            "border": {
                "color": "#e4e2dd"
            },
            "color": "#1e1b15",
            "close": {
                "button": {
                    "hover": {
                        "background": "#e4e2dd"
                    },
                    "focus": {
                        "ring": {
                            "color": "#868074",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "outlined": {
                "color": "#99948a",
                "border": {
                    "color": "#99948a"
                }
            },
            "simple": {
                "color": "#99948a"
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(4, 5, 6, 0.04)",
                "type": "dropShadow"
            }
        },
        "contrast": {
            "background": "#312d25",
            "border": {
                "color": "#1e1b15"
            },
            "color": "#faf9f7",
            "detail": {
                "color": "#fffffe"
            },
            "close": {
                "button": {
                    "hover": {
                        "background": "#474238"
                    },
                    "focus": {
                        "ring": {
                            "color": "#faf9f7",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "outlined": {
                "color": "#1e1b15",
                "border": {
                    "color": "#1e1b15"
                }
            },
            "simple": {
                "color": "#1e1b15"
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(0, 0, 1, 0.04)",
                "type": "dropShadow"
            }
        },
        "border": {
            "radius": "6px",
            "width": "1px"
        },
        "content": {
            "padding": "0.5rem 0.75rem",
            "gap": "0.5rem",
            "sm": {
                "padding": "0.375rem 0.625rem"
            },
            "lg": {
                "padding": "0.625rem 0.875rem"
            }
        },
        "text": {
            "font": {
                "size": "1rem",
                "weight": "500"
            },
            "sm": {
                "font": {
                    "size": "0.875rem"
                }
            },
            "lg": {
                "font": {
                    "size": "1.125rem"
                }
            }
        },
        "icon": {
            "size": "1.125rem",
            "sm": {
                "size": "1rem"
            },
            "lg": {
                "size": "1.25rem"
            }
        },
        "close": {
            "button": {
                "width": "1.75rem",
                "height": "1.75rem",
                "border": {
                    "radius": "0.875rem"
                },
                "focus": {
                    "ring": {
                        "width": "1",
                        "style": "solid",
                        "offset": "2"
                    }
                }
            },
            "icon": {
                "size": "1rem",
                "sm": {
                    "size": "0.875rem"
                },
                "lg": {
                    "size": "1.125rem"
                }
            }
        },
        "outlined": {
            "border": {
                "width": "1px"
            }
        },
        "simple": {
            "content": {
                "padding": "0"
            }
        }
    },
    "toast": {
        "info": {
            "background": "rgb(93.725% 96.471% 100% / 0.95)",
            "border": {
                "color": "#bfdbfe"
            },
            "color": "#2563eb",
            "detail": {
                "color": "#686257"
            },
            "close": {
                "button": {
                    "hover": {
                        "background": "#dbeafe"
                    },
                    "focus": {
                        "ring": {
                            "color": "#2563eb",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(2, 5, 10, 0.04)",
                "type": "dropShadow"
            }
        },
        "success": {
            "background": "rgb(94.118% 99.216% 95.686% / 0.95)",
            "border": {
                "color": "#bbf7d0"
            },
            "color": "#16a34a",
            "detail": {
                "color": "#686257"
            },
            "close": {
                "button": {
                    "hover": {
                        "background": "#dcfce7"
                    },
                    "focus": {
                        "ring": {
                            "color": "#16a34a",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(1, 8, 4, 0.04)",
                "type": "dropShadow"
            }
        },
        "warn": {
            "background": "rgb(99.608% 98.824% 90.98% / 0.95)",
            "border": {
                "color": "#fef08a"
            },
            "color": "#ca8a04",
            "detail": {
                "color": "#686257"
            },
            "close": {
                "button": {
                    "hover": {
                        "background": "#fef9c3"
                    },
                    "focus": {
                        "ring": {
                            "color": "#ca8a04",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(9, 7, 0, 0.04)",
                "type": "dropShadow"
            }
        },
        "error": {
            "background": "rgb(100% 92.941% 92.157% / 0.95)",
            "border": {
                "color": "#ffb4ac"
            },
            "color": "#b32927",
            "close": {
                "button": {
                    "hover": {
                        "background": "#ffdad6"
                    },
                    "focus": {
                        "ring": {
                            "color": "#b32927",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "outlined": {
                "color": "#b32927",
                "border": {
                    "color": "#b32927"
                }
            },
            "simple": {
                "color": "#b32927"
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(10, 3, 3, 0.04)",
                "type": "dropShadow"
            }
        },
        "secondary": {
            "background": "#f4f2ee",
            "border": {
                "color": "#e4e2dd"
            },
            "color": "#868074",
            "detail": {
                "color": "#686257"
            },
            "close": {
                "button": {
                    "hover": {
                        "background": "#e4e2dd"
                    },
                    "focus": {
                        "ring": {
                            "color": "#868074",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(4, 5, 6, 0.04)",
                "type": "dropShadow"
            }
        },
        "contrast": {
            "background": "#312d25",
            "border": {
                "color": "#1e1b15"
            },
            "color": "#faf9f7",
            "detail": {
                "color": "#fffffe"
            },
            "close": {
                "button": {
                    "hover": {
                        "background": "#474238"
                    },
                    "focus": {
                        "ring": {
                            "color": "#faf9f7",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "shadow": {
                "x": "0",
                "y": "4",
                "blur": "8",
                "spread": "0",
                "color": "rgba(0, 0, 1, 0.04)",
                "type": "dropShadow"
            }
        },
        "width": "25rem",
        "border": {
            "radius": "6px",
            "width": "1px"
        },
        "icon": {
            "size": "1.125rem"
        },
        "content": {
            "padding": "0.75rem",
            "gap": "0.5rem"
        },
        "summary": {
            "font": {
                "weight": "500",
                "size": "1rem"
            }
        },
        "detail": {
            "font": {
                "weight": "500",
                "size": "0.875rem"
            }
        },
        "close": {
            "button": {
                "width": "1.75rem",
                "height": "1.75rem",
                "border": {
                    "radius": "0.875rem"
                },
                "focus": {
                    "ring": {
                        "width": "1",
                        "style": "solid",
                        "offset": "2"
                    }
                }
            },
            "icon": {
                "size": "1rem"
            }
        },
        "text": {
            "gap": "0.5rem"
        }
    },
    "galleria": {
        "thumbnail": {
            "nav": {
                "button": {
                    "hover": {
                        "background": "#f4f2ee",
                        "color": "#686257"
                    },
                    "color": "#868074",
                    "size": "2rem",
                    "border": {
                        "radius": "6px"
                    },
                    "gutter": "0.5rem",
                    "focus": {
                        "ring": {
                            "width": "1",
                            "style": "solid",
                            "color": "#1e1b15",
                            "offset": "2",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    },
                    "icon": {
                        "size": "1rem"
                    }
                }
            }
        },
        "indicator": {
            "button": {
                "background": "#e4e2dd",
                "hover": {
                    "background": "#cfccc5"
                },
                "width": "1rem",
                "height": "1rem",
                "active": {
                    "background": "#1e1b15"
                },
                "border": {
                    "radius": "0.5rem"
                },
                "focus": {
                    "ring": {
                        "width": "1",
                        "offset": "2",
                        "style": "solid",
                        "color": "#1e1b15",
                        "shadow": {
                            "x": "0",
                            "y": "0",
                            "blur": "0",
                            "spread": "0",
                            "color": "rgba(0, 0, 0, 0)",
                            "type": "dropShadow"
                        }
                    }
                }
            },
            "list": {
                "gap": "0.5rem",
                "padding": "1rem"
            }
        },
        "border": {
            "width": "1px",
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "nav": {
            "button": {
                "background": "rgba(255, 255, 255, 0.1)",
                "hover": {
                    "background": "rgba(255, 255, 255, 0.2)",
                    "color": "#fffffe"
                },
                "color": "#f4f2ee",
                "size": "3rem",
                "gutter": "0.5rem",
                "prev": {
                    "border": {
                        "radius": "1.5rem"
                    }
                },
                "next": {
                    "border": {
                        "radius": "1.5rem"
                    }
                },
                "focus": {
                    "ring": {
                        "width": "1",
                        "style": "solid",
                        "color": "#1e1b15",
                        "offset": "2",
                        "shadow": {
                            "x": "0",
                            "y": "0",
                            "blur": "0",
                            "spread": "0",
                            "color": "rgba(0, 0, 0, 0)",
                            "type": "dropShadow"
                        }
                    }
                }
            },
            "icon": {
                "size": "1.5rem"
            }
        },
        "thumbnails": {
            "content": {
                "background": "#fffffe",
                "padding": "1rem 0.25rem"
            }
        },
        "caption": {
            "background": "rgba(0, 0, 0, 0.5)",
            "color": "#f4f2ee",
            "padding": "1rem"
        },
        "inset": {
            "indicator": {
                "list": {
                    "background": "rgba(0, 0, 0, 0.5)"
                },
                "button": {
                    "background": "rgba(255, 255, 255, 0.4)",
                    "hover": {
                        "background": "rgba(255, 255, 255, 0.6)"
                    },
                    "active": {
                        "background": "rgba(255, 255, 255, 0.9)"
                    }
                }
            }
        },
        "close": {
            "button": {
                "size": "3rem",
                "gutter": "0.5rem",
                "background": "rgba(255, 255, 255, 0.1)",
                "hover": {
                    "background": "rgba(255, 255, 255, 0.2)",
                    "color": "#fffffe"
                },
                "color": "#faf9f7",
                "border": {
                    "radius": "1.5rem"
                },
                "focus": {
                    "ring": {
                        "width": "1",
                        "offset": "2",
                        "style": "solid",
                        "color": "#1e1b15",
                        "shadow": {
                            "x": "0",
                            "y": "0",
                            "blur": "0",
                            "spread": "0",
                            "color": "rgba(0, 0, 0, 0)",
                            "type": "dropShadow"
                        }
                    }
                },
                "icon": {
                    "size": "1.5rem"
                }
            }
        }
    },
    "tabs": {
        "nav": {
            "button": {
                "background": "#fffffe",
                "color": "#686257",
                "hover": {
                    "color": "#0c0800"
                },
                "width": "2.5rem",
                "focus": {
                    "ring": {
                        "color": "#1e1b15",
                        "width": "1",
                        "offset": "-1",
                        "style": "solid",
                        "shadow": {
                            "x": "0",
                            "y": "0",
                            "blur": "0",
                            "spread": "0",
                            "color": "rgba(0, 0, 0, 0)",
                            "type": "dropShadow"
                        }
                    }
                },
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "10",
                    "spread": "50",
                    "color": "rgba(255, 255, 255, 0.6)",
                    "type": "dropShadow"
                }
            }
        },
        "tablist": {
            "background": "rgba(0, 0, 0, 0)",
            "border": {
                "color": "#e4e2dd",
                "width": "1"
            }
        },
        "tab": {
            "border": {
                "color": "#e4e2dd",
                "width": "2"
            },
            "active": {
                "border": {
                    "color": "#c1ac00"
                },
                "color": "#0c0800",
                "background": "rgba(0, 0, 0, 0)"
            },
            "color": "#686257",
            "hover": {
                "color": "#0c0800",
                "background": "rgba(0, 0, 0, 0)",
                "border": {
                    "color": "#e4e2dd"
                }
            },
            "background": "rgba(0, 0, 0, 0)",
            "padding": "0.5rem 0.75rem",
            "font": {
                "weight": "600"
            },
            "margin": "0 -1px 0",
            "gap": "0.5rem",
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "-1",
                    "style": "solid",
                    "color": "#1e1b15",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        },
        "tabpanel": {
            "background": "#fffffe",
            "color": "#0c0800",
            "padding": "0.875rem 1.125rem 1.125rem 1.125rem",
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "2",
                    "color": "#1e1b15",
                    "style": "solid",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        },
        "active": {
            "bar": {
                "height": "1px",
                "bottom": "-1px",
                "background": "#1e1b15"
            }
        }
    },
    "dataview": {
        "border": {
            "color": "rgba(0, 0, 0, 0)",
            "width": "0",
            "radius": "0"
        },
        "padding": "0",
        "header": {
            "background": "#fffffe",
            "color": "#0c0800",
            "border": {
                "color": "#e4e2dd",
                "width": "1",
                "radius": "0"
            },
            "padding": "0.75rem 1rem"
        },
        "content": {
            "background": "#fffffe",
            "color": "#0c0800",
            "border": {
                "color": "rgba(0, 0, 0, 0)",
                "radius": "0",
                "width": "0"
            },
            "padding": "0"
        },
        "footer": {
            "background": "#fffffe",
            "color": "#0c0800",
            "border": {
                "color": "#e4e2dd",
                "width": "1",
                "radius": "0"
            },
            "padding": "0.75rem 1rem"
        },
        "paginator": {
            "top": {
                "border": {
                    "color": "#e4e2dd",
                    "width": "1"
                }
            },
            "bottom": {
                "border": {
                    "width": "1",
                    "color": "#e4e2dd"
                }
            }
        }
    },
    "progressspinner": {
        "color": {
            "1": "#f85b53",
            "2": "#3b82f6",
            "3": "#22c55e",
            "4": "#eab308"
        }
    },
    "surface": {
        "0": "#fffffe",
        "50": "#faf9f7",
        "100": "#f4f2ee",
        "200": "#e4e2dd",
        "300": "#cfccc5",
        "400": "#b6b2aa",
        "500": "#99948a",
        "600": "#868074",
        "700": "#686257",
        "800": "#474238",
        "900": "#312d25",
        "950": "#1e1b15"
    },
    "primary": {
        "50": "#faf9f7",
        "100": "#f4f2ee",
        "200": "#e4e2dd",
        "300": "#cfccc5",
        "400": "#b6b2aa",
        "500": "#99948a",
        "600": "#868074",
        "700": "#686257",
        "800": "#474238",
        "900": "#312d25",
        "950": "#1e1b15",
        "color": "#1e1b15",
        "contrast": {
            "color": "#fffffe"
        },
        "hover": {
            "color": "#312d25"
        },
        "active": {
            "color": "#686257"
        }
    },
    "highlight": {
        "background": "#faf9f7",
        "focus": {
            "background": "#f4f2ee",
            "color": "#474238"
        },
        "color": "#686257"
    },
    "mask": {
        "background": "rgba(0, 0, 0, 0.4)",
        "color": "#e4e2dd"
    },
    "form": {
        "field": {
            "background": "#fffffe",
            "disabled": {
                "background": "#e4e2dd",
                "color": "#99948a"
            },
            "filled": {
                "background": "#faf9f7",
                "focus": {
                    "background": "#faf9f7"
                },
                "hover": {
                    "background": "#faf9f7"
                }
            },
            "border": {
                "color": "#f4f2ee",
                "radius": "6px"
            },
            "hover": {
                "border": {
                    "color": "#b6b2aa"
                }
            },
            "focus": {
                "border": {
                    "color": "#1e1b15"
                },
                "ring": {
                    "width": "0",
                    "style": "none",
                    "color": "rgba(0, 0, 0, 0)",
                    "offset": "0",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            },
            "invalid": {
                "border": {
                    "color": "#900b13"
                },
                "placeholder": {
                    "color": "#b32927"
                }
            },
            "placeholder": {
                "color": "#686257"
            },
            "float": {
                "label": {
                    "color": "#99948a",
                    "focus": {
                        "color": "#99948a"
                    },
                    "invalid": {
                        "color": "#b32927"
                    }
                }
            },
            "icon": {
                "color": "#1e1b15"
            },
            "color": "#1e1b15",
            "padding": {
                "x": "0.75rem",
                "y": "0.5rem"
            },
            "sm": {
                "font": {
                    "size": "0.875rem"
                },
                "padding": {
                    "x": "0.625rem",
                    "y": "0.375rem"
                }
            },
            "lg": {
                "font": {
                    "size": "1.125rem"
                },
                "padding": {
                    "x": "0.875rem",
                    "y": "0.625rem"
                }
            },
            "shadow": {
                "x": "0",
                "y": "1",
                "blur": "2",
                "spread": "0",
                "color": "rgba(18, 18, 23, 0.05)",
                "type": "dropShadow"
            }
        }
    },
    "content": {
        "background": "#fffffe",
        "hover": {
            "background": "#faf9f7",
            "color": "#1e1b15"
        },
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800"
    },
    "text": {
        "color": "#0c0800",
        "hover": {
            "color": "#1e1b15",
            "muted": {
                "color": "#686257"
            }
        },
        "muted": {
            "color": "#686257"
        }
    },
    "overlay": {
        "select": {
            "background": "rgba(255, 255, 255, 0.9)",
            "border": {
                "color": "#f4f2ee",
                "radius": "8px"
            },
            "color": "#0c0800",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "popover": {
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "radius": "6px"
            },
            "color": "#0c0800",
            "padding": "0.75rem",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "modal": {
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "radius": "12px"
            },
            "color": "#0c0800",
            "padding": "1.25rem",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "20",
                    "blur": "25",
                    "spread": "-5",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "8",
                    "blur": "10",
                    "spread": "-6",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "title": {
            "font": {
                "size": "1.5rem"
            }
        },
        "navigation": {
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        }
    },
    "list": {
        "option": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "selected": {
                "background": "#faf9f7",
                "focus": {
                    "background": "#f4f2ee",
                    "color": "#474238"
                },
                "color": "#686257"
            },
            "color": "#0c0800",
            "icon": {
                "color": "#b6b2aa",
                "focus": {
                    "color": "#99948a"
                }
            },
            "group": {
                "background": "rgba(0, 0, 0, 0)",
                "color": "#686257",
                "padding": "0.5rem 0.75rem",
                "font": {
                    "weight": "600"
                }
            },
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            }
        },
        "padding": "0.25rem 0.25rem",
        "gap": "2px",
        "header": {
            "padding": "0.5rem 0.75rem 0.25rem 0.75rem"
        }
    },
    "navigation": {
        "item": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "active": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "color": "#0c0800",
            "icon": {
                "color": "#0c0800",
                "focus": {
                    "color": "#0c0800"
                },
                "active": {
                    "color": "#0c0800"
                }
            },
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "gap": "0.5rem"
        },
        "submenu": {
            "label": {
                "background": "rgba(0, 0, 0, 0)",
                "color": "#686257",
                "padding": "0.5rem 0.75rem",
                "font": {
                    "weight": "600"
                }
            },
            "icon": {
                "color": "#b6b2aa",
                "focus": {
                    "color": "#99948a"
                },
                "active": {
                    "color": "#99948a"
                },
                "size": "0.875rem"
            }
        },
        "list": {
            "padding": "0.25rem 0.25rem",
            "gap": "2px"
        }
    },
    "inputtext": {
        "background": "#fffffe",
        "disabled": {
            "background": "#e4e2dd",
            "color": "#99948a"
        },
        "filled": {
            "background": "#faf9f7",
            "focus": {
                "background": "#faf9f7"
            },
            "hover": {
                "background": "#faf9f7"
            }
        },
        "border": {
            "color": "#f4f2ee",
            "radius": "6px"
        },
        "hover": {
            "border": {
                "color": "#b6b2aa"
            }
        },
        "focus": {
            "border": {
                "color": "#1e1b15"
            },
            "ring": {
                "width": "0",
                "style": "none",
                "color": "rgba(0, 0, 0, 0)",
                "offset": "0",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            },
            "placeholder": {
                "color": "#b32927"
            }
        },
        "color": "#1e1b15",
        "placeholder": {
            "color": "#686257"
        },
        "padding": {
            "x": "0.75rem",
            "y": "0.5rem"
        },
        "sm": {
            "font": {
                "size": "0.875rem"
            },
            "padding": {
                "x": "0.625rem",
                "y": "0.375rem"
            }
        },
        "lg": {
            "padding": {
                "x": "0.875rem",
                "y": "0.625rem"
            },
            "font": {
                "size": "1.125rem"
            }
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "panel": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "header": {
            "background": "rgba(0, 0, 0, 0)",
            "color": "#0c0800",
            "border": {
                "color": "#e4e2dd",
                "radius": "0"
            },
            "padding": "1.125rem"
        },
        "toggleableHeader": {
            "padding": "0.375rem 1.125rem"
        },
        "title": {
            "font": {
                "weight": "600"
            }
        },
        "content": {
            "padding": "0 1.125rem 1.125rem 1.125rem"
        },
        "footer": {
            "padding": "0 1.125rem 1.125rem 1.125rem"
        }
    },
    "iconfield": {
        "icon": {
            "color": "#1e1b15"
        }
    },
    "float": {
        "label": {
            "color": "#99948a",
            "focus": {
                "color": "#99948a"
            },
            "invalid": {
                "color": "#b32927"
            }
        }
    },
    "radiobutton": {
        "width": "1.25rem",
        "height": "1.25rem",
        "background": "#fffffe",
        "checked": {
            "background": "#1e1b15",
            "hover": {
                "background": "#312d25",
                "border": {
                    "color": "#312d25"
                }
            },
            "border": {
                "color": "#1e1b15"
            },
            "focus": {
                "border": {
                    "color": "#1e1b15"
                }
            },
            "disabled": {
                "border": {
                    "color": "#f4f2ee"
                }
            }
        },
        "disabled": {
            "background": "#e4e2dd"
        },
        "filled": {
            "background": "#faf9f7"
        },
        "border": {
            "color": "#e4e2dd"
        },
        "hover": {
            "border": {
                "color": "#b6b2aa"
            }
        },
        "focus": {
            "border": {
                "color": "#f4f2ee"
            },
            "ring": {
                "width": "1",
                "style": "solid",
                "color": "#1e1b15",
                "offset": "2",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            }
        },
        "icon": {
            "size": "0.75rem",
            "checked": {
                "color": "#fffffe",
                "hover": {
                    "color": "#fffffe"
                }
            },
            "disabled": {
                "color": "#99948a"
            },
            "sm": {
                "size": "0.5rem"
            },
            "lg": {
                "size": "1rem"
            }
        },
        "sm": {
            "width": "1rem",
            "height": "1rem"
        },
        "lg": {
            "width": "1.5rem",
            "height": "1.5rem"
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "checkbox": {
        "border": {
            "radius": "4px",
            "color": "#e4e2dd"
        },
        "width": "1.25rem",
        "height": "1.25rem",
        "background": "#fffffe",
        "checked": {
            "background": "#1e1b15",
            "hover": {
                "background": "#312d25",
                "border": {
                    "color": "#312d25"
                }
            },
            "border": {
                "color": "#1e1b15"
            },
            "focus": {
                "border": {
                    "color": "#1e1b15"
                }
            },
            "disabled": {
                "border": {
                    "color": "#f4f2ee"
                }
            }
        },
        "disabled": {
            "background": "#e4e2dd"
        },
        "filled": {
            "background": "#faf9f7"
        },
        "hover": {
            "border": {
                "color": "#b6b2aa"
            }
        },
        "focus": {
            "border": {
                "color": "#f4f2ee"
            },
            "ring": {
                "width": "1",
                "style": "solid",
                "color": "#1e1b15",
                "offset": "2",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            }
        },
        "icon": {
            "size": "0.875rem",
            "color": "#1e1b15",
            "checked": {
                "color": "#fffffe",
                "hover": {
                    "color": "#fffffe"
                }
            },
            "disabled": {
                "color": "#99948a"
            },
            "sm": {
                "size": "0.75rem"
            },
            "lg": {
                "size": "1rem"
            }
        },
        "sm": {
            "width": "1rem",
            "height": "1rem"
        },
        "lg": {
            "width": "1.5rem",
            "height": "1.5rem"
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "rating": {
        "gap": "0.25rem",
        "icon": {
            "size": "1rem"
        },
        "color": "#686257",
        "hover": {
            "color": "#1e1b15"
        },
        "active": {
            "color": "#1e1b15"
        },
        "focus": {
            "ring": {
                "width": "1",
                "style": "solid",
                "color": "#1e1b15",
                "offset": "2",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        }
    },
    "avatar": {
        "width": "1.5rem",
        "height": "1.5rem",
        "font": {
            "size": "0.7rem"
        },
        "icon": {
            "size": "0.7rem"
        },
        "background": "#e4e2dd",
        "border": {
            "radius": "6px"
        },
        "group": {
            "border": {
                "color": "#fffffe"
            },
            "offset": "-1.5rem",
            "stroke": {
                "color": "#fffffe",
                "width": "2px",
                "style": "solid"
            }
        },
        "lg": {
            "width": "2rem",
            "height": "2rem",
            "font": {
                "size": "1rem"
            },
            "icon": {
                "size": "1rem"
            },
            "group": {
                "offset": "-0.75rem"
            }
        },
        "xl": {
            "width": "3rem",
            "height": "3rem",
            "font": {
                "size": "1.5rem"
            },
            "icon": {
                "size": "1.5rem"
            },
            "group": {
                "offset": "-1rem"
            }
        },
        "color": "#0c0800"
    },
    "progressbar": {
        "background": "#e4e2dd",
        "border": {
            "radius": "6px"
        },
        "value": {
            "background": "#1e1b15"
        },
        "label": {
            "color": "#fffffe",
            "font": {
                "weight": "600"
            }
        },
        "font": {
            "size": "0.75rem"
        },
        "height": "1.25rem"
    },
    "card": {
        "background": "#fffffe",
        "border": {
            "radius": "12px"
        },
        "color": "#0c0800",
        "body": {
            "padding": "1.25rem",
            "gap": "0.5rem"
        },
        "caption": {
            "gap": "0.5rem"
        },
        "title": {
            "font": {
                "size": "1.25rem",
                "weight": "500"
            }
        },
        "subtitle": {
            "color": "#686257"
        },
        "shadow": {
            "1": {
                "x": "0",
                "y": "1",
                "blur": "3",
                "spread": "0",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            },
            "2": {
                "x": "0",
                "y": "1",
                "blur": "2",
                "spread": "-1",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            }
        }
    },
    "breadcrumb": {
        "padding": "1rem",
        "background": "#fffffe",
        "gap": "0.5rem",
        "item": {
            "color": "#686257",
            "hover": {
                "color": "#0c0800"
            },
            "icon": {
                "color": "#0c0800",
                "hover": {
                    "color": "#0c0800"
                }
            },
            "border": {
                "radius": "6px"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "style": "solid",
                    "color": "#1e1b15",
                    "offset": "2",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        },
        "separator": {
            "color": "#0c0800"
        }
    },
    "drawer": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "12px"
        },
        "color": "#0c0800",
        "header": {
            "padding": "1.25rem"
        },
        "title": {
            "font": {
                "weight": "600",
                "size": "1.5rem"
            }
        },
        "content": {
            "padding": "0 1.25rem 1.25rem 1.25rem"
        },
        "shadow": {
            "1": {
                "x": "0",
                "y": "20",
                "blur": "25",
                "spread": "-5",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            },
            "2": {
                "x": "0",
                "y": "8",
                "blur": "10",
                "spread": "-6",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            }
        }
    },
    "cascadeselect": {
        "background": "#fffffe",
        "disabled": {
            "background": "#e4e2dd",
            "color": "#99948a"
        },
        "filled": {
            "background": "#faf9f7",
            "focus": {
                "background": "#faf9f7"
            },
            "hover": {
                "background": "#faf9f7"
            }
        },
        "border": {
            "color": "#f4f2ee",
            "radius": "6px"
        },
        "hover": {
            "border": {
                "color": "#b6b2aa"
            }
        },
        "focus": {
            "border": {
                "color": "#1e1b15"
            },
            "ring": {
                "width": "0",
                "style": "none",
                "color": "rgba(0, 0, 0, 0)",
                "offset": "0",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            },
            "placeholder": {
                "color": "#b32927"
            }
        },
        "color": "#1e1b15",
        "placeholder": {
            "color": "#686257"
        },
        "padding": {
            "x": "0.75rem",
            "y": "0.5rem"
        },
        "dropdown": {
            "width": "2.5rem",
            "color": "#1e1b15"
        },
        "overlay": {
            "background": "rgba(255, 255, 255, 0.9)",
            "border": {
                "color": "#f4f2ee",
                "radius": "8px"
            },
            "color": "#0c0800",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "list": {
            "padding": "0.25rem 0.25rem",
            "gap": "2px",
            "mobile": {
                "indent": "1rem"
            }
        },
        "option": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "selected": {
                "background": "#faf9f7",
                "focus": {
                    "background": "#f4f2ee",
                    "color": "#474238"
                },
                "color": "#686257"
            },
            "color": "#0c0800",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "icon": {
                "color": "#b6b2aa",
                "focus": {
                    "color": "#99948a"
                },
                "size": "0.875rem"
            }
        },
        "sm": {
            "font": {
                "size": "0.875rem"
            },
            "padding": {
                "x": "0.625rem",
                "y": "0.375rem"
            }
        },
        "lg": {
            "font": {
                "size": "1.125rem"
            },
            "padding": {
                "x": "0.875rem",
                "y": "0.625rem"
            }
        },
        "clear": {
            "icon": "#1e1b15"
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "select": {
        "background": "#fffffe",
        "disabled": {
            "background": "#e4e2dd",
            "color": "#99948a"
        },
        "filled": {
            "background": "#faf9f7",
            "focus": {
                "background": "#faf9f7"
            },
            "hover": {
                "background": "#faf9f7"
            }
        },
        "border": {
            "color": "#f4f2ee",
            "radius": "6px"
        },
        "hover": {
            "border": {
                "color": "#b6b2aa"
            }
        },
        "focus": {
            "border": {
                "color": "#1e1b15"
            },
            "ring": {
                "width": "0",
                "offset": "0",
                "style": "none",
                "color": "rgba(0, 0, 0, 0)",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            },
            "placeholder": {
                "color": "#b32927"
            }
        },
        "color": "#1e1b15",
        "placeholder": {
            "color": "#686257"
        },
        "padding": {
            "x": "0.75rem",
            "y": "0.5rem"
        },
        "dropdown": {
            "width": "2.5rem",
            "color": "#1e1b15"
        },
        "overlay": {
            "background": "rgba(255, 255, 255, 0.9)",
            "border": {
                "color": "#f4f2ee",
                "radius": "8px"
            },
            "color": "#0c0800",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "list": {
            "padding": "0.25rem 0.25rem",
            "gap": "2px",
            "header": {
                "padding": "0.5rem 0.75rem 0.25rem 0.75rem"
            }
        },
        "option": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "selected": {
                "background": "#faf9f7",
                "focus": {
                    "background": "#f4f2ee",
                    "color": "#474238"
                },
                "color": "#686257"
            },
            "color": "#0c0800",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "group": {
                "background": "rgba(0, 0, 0, 0)",
                "color": "#686257",
                "font": {
                    "weight": "600"
                },
                "padding": "0.5rem 0.75rem"
            }
        },
        "clear": {
            "icon": {
                "color": "#1e1b15"
            }
        },
        "checkmark": {
            "color": "#0c0800",
            "gutter": {
                "start": "-0.375rem",
                "end": "0.375rem"
            }
        },
        "empty": {
            "message": {
                "padding": "0.5rem 0.75rem"
            }
        },
        "sm": {
            "font": {
                "size": "0.875rem"
            },
            "padding": {
                "x": "0.625rem",
                "y": "0.375rem"
            }
        },
        "lg": {
            "font": {
                "size": "1.125rem"
            },
            "padding": {
                "x": "0.875rem",
                "y": "0.625rem"
            }
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "editor": {
        "toolbar": {
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "radius": "6px"
            },
            "item": {
                "color": "#686257",
                "hover": {
                    "color": "#0c0800"
                },
                "active": {
                    "color": "#1e1b15"
                }
            }
        },
        "overlay": {
            "background": "rgba(255, 255, 255, 0.9)",
            "border": {
                "color": "#f4f2ee",
                "radius": "8px"
            },
            "color": "#0c0800",
            "padding": "0.25rem 0.25rem",
            "option": {
                "focus": {
                    "background": "#f4f2ee",
                    "color": "#1e1b15"
                },
                "color": "#0c0800",
                "padding": "0.5rem 0.75rem",
                "border": {
                    "radius": "4px"
                }
            },
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "content": {
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "radius": "6px"
            },
            "color": "#0c0800"
        }
    },
    "inputgroup": {
        "addon": {
            "background": "#fffffe",
            "border": {
                "color": "#f4f2ee",
                "radius": "6px"
            },
            "color": "#1e1b15",
            "padding": "0.5rem",
            "min": {
                "width": "2.5rem"
            }
        }
    },
    "textarea": {
        "background": "#fffffe",
        "disabled": {
            "background": "#e4e2dd",
            "color": "#99948a"
        },
        "filled": {
            "background": "#faf9f7",
            "focus": {
                "background": "#faf9f7"
            }
        },
        "border": {
            "color": "#f4f2ee",
            "radius": "6px"
        },
        "hover": {
            "border": {
                "color": "#b6b2aa"
            }
        },
        "focus": {
            "border": {
                "color": "#1e1b15"
            },
            "ring": {
                "width": "0",
                "offset": "0",
                "color": "rgba(0, 0, 0, 0)",
                "style": "none",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            },
            "placeholder": {
                "color": "#b32927"
            }
        },
        "color": "#1e1b15",
        "placeholder": {
            "color": "#686257"
        },
        "padding": {
            "x": "0.75rem",
            "y": "0.5rem"
        },
        "sm": {
            "padding": {
                "x": "0.625rem",
                "y": "0.375rem"
            },
            "font": {
                "size": "0.875rem"
            }
        },
        "lg": {
            "padding": {
                "x": "0.875rem",
                "y": "0.625rem"
            },
            "font": {
                "size": "1.125rem"
            }
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "knob": {
        "focus": {
            "ring": {
                "width": "1",
                "offset": "2",
                "color": "#1e1b15",
                "style": "solid",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "value": {
            "background": "#1e1b15"
        },
        "range": {
            "background": "#e4e2dd"
        },
        "text": {
            "color": "#686257"
        }
    },
    "multiselect": {
        "background": "#fffffe",
        "disabled": {
            "background": "#e4e2dd",
            "color": "#99948a"
        },
        "filled": {
            "background": "#faf9f7",
            "focus": {
                "background": "#faf9f7"
            },
            "hover": {
                "background": "#faf9f7"
            }
        },
        "border": {
            "color": "#f4f2ee",
            "radius": "6px"
        },
        "hover": {
            "border": {
                "color": "#b6b2aa"
            }
        },
        "focus": {
            "border": {
                "color": "#1e1b15"
            },
            "ring": {
                "width": "0",
                "offset": "0",
                "style": "none",
                "color": "rgba(0, 0, 0, 0)",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            },
            "placeholder": {
                "color": "#b32927"
            }
        },
        "color": "#1e1b15",
        "placeholder": {
            "color": "#686257"
        },
        "padding": {
            "x": "0.75rem",
            "y": "0.5rem"
        },
        "dropdown": {
            "width": "2.5rem",
            "color": "#1e1b15"
        },
        "overlay": {
            "background": "rgba(255, 255, 255, 0.9)",
            "border": {
                "color": "#f4f2ee",
                "radius": "8px"
            },
            "color": "#0c0800",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "list": {
            "padding": "0.25rem 0.25rem",
            "gap": "2px",
            "header": {
                "padding": "0.5rem 0.75rem 0.25rem 0.75rem"
            }
        },
        "header": {
            "padding": "0.5rem 0.75rem 0.25rem 0.75rem"
        },
        "option": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "selected": {
                "background": "#faf9f7",
                "focus": {
                    "background": "#f4f2ee",
                    "color": "#474238"
                },
                "color": "#686257"
            },
            "color": "#0c0800",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "gap": "0.5rem",
            "group": {
                "background": "rgba(0, 0, 0, 0)",
                "color": "#686257",
                "font": {
                    "weight": "600"
                },
                "padding": "0.5rem 0.75rem"
            }
        },
        "chip": {
            "border": {
                "radius": "4px"
            }
        },
        "empty": {
            "message": {
                "padding": "0.5rem 0.75rem"
            }
        },
        "sm": {
            "padding": {
                "x": "0.625rem",
                "y": "0.375rem"
            },
            "font": {
                "size": "0.875rem"
            }
        },
        "lg": {
            "padding": {
                "x": "0.875rem",
                "y": "0.625rem"
            },
            "font": {
                "size": "1.125rem"
            }
        },
        "clear": {
            "icon": "#1e1b15"
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "treeselect": {
        "background": "#fffffe",
        "disabled": {
            "background": "#e4e2dd",
            "color": "#99948a"
        },
        "filled": {
            "background": "#faf9f7",
            "focus": {
                "background": "#faf9f7"
            },
            "hover": {
                "background": "#faf9f7"
            }
        },
        "border": {
            "color": "#f4f2ee",
            "radius": "6px"
        },
        "hover": {
            "border": {
                "color": "#b6b2aa"
            }
        },
        "focus": {
            "border": {
                "color": "#1e1b15"
            },
            "ring": {
                "width": "0",
                "offset": "0",
                "color": "rgba(0, 0, 0, 0)",
                "style": "none",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "invalid": {
            "border": {
                "color": "#900b13"
            },
            "placeholder": {
                "color": "#b32927"
            }
        },
        "color": "#1e1b15",
        "placeholder": {
            "color": "#686257"
        },
        "padding": {
            "x": "0.75rem",
            "y": "0.5rem"
        },
        "dropdown": {
            "width": "2.5rem",
            "color": "#1e1b15"
        },
        "overlay": {
            "background": "rgba(255, 255, 255, 0.9)",
            "border": {
                "color": "#f4f2ee",
                "radius": "8px"
            },
            "color": "#0c0800",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "tree": {
            "padding": "0.25rem 0.25rem"
        },
        "empty": {
            "message": {
                "padding": "0.5rem 0.75rem"
            }
        },
        "chip": {
            "border": {
                "radius": "4px"
            }
        },
        "sm": {
            "font": {
                "size": "0.875rem"
            },
            "padding": {
                "x": "0.625rem",
                "y": "0.375rem"
            }
        },
        "lg": {
            "font": {
                "size": "1.125rem"
            },
            "padding": {
                "x": "0.875rem",
                "y": "0.625rem"
            }
        },
        "clear": {
            "icon": "#1e1b15"
        },
        "shadow": {
            "x": "0",
            "y": "1",
            "blur": "2",
            "spread": "0",
            "color": "rgba(18, 18, 23, 0.05)",
            "type": "dropShadow"
        }
    },
    "accordion": {
        "panel": {
            "border": {
                "width": "1",
                "color": "#e4e2dd"
            }
        },
        "header": {
            "color": "#686257",
            "hover": {
                "color": "#0c0800",
                "background": "#fffffe"
            },
            "active": {
                "color": "#0c0800",
                "background": "#fffffe",
                "hover": {
                    "background": "#fffffe"
                }
            },
            "padding": "1.125rem",
            "font": {
                "weight": "600"
            },
            "border": {
                "radius": "0",
                "width": "0",
                "color": "#e4e2dd"
            },
            "background": "#fffffe",
            "focus": {
                "ring": {
                    "width": "1",
                    "style": "solid",
                    "color": "#1e1b15",
                    "offset": "2",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            },
            "toggle": {
                "icon": {
                    "color": "#686257",
                    "hover": {
                        "color": "#0c0800"
                    },
                    "active": {
                        "color": "#0c0800",
                        "hover": {
                            "color": "#0c0800"
                        }
                    }
                }
            },
            "first": {
                "top": {
                    "border": {
                        "radius": "6px"
                    }
                },
                "border": {
                    "width": "0"
                }
            },
            "last": {
                "bottom": {
                    "border": {
                        "radius": "6px"
                    }
                },
                "active": {
                    "bottom": {
                        "border": {
                            "radius": "0"
                        }
                    }
                }
            }
        },
        "content": {
            "border": {
                "width": "0",
                "color": "#e4e2dd"
            },
            "background": "#fffffe",
            "color": "#0c0800",
            "padding": "0 1.125rem 1.125rem 1.125rem"
        }
    },
    "divider": {
        "border": {
            "color": "#e4e2dd"
        },
        "content": {
            "background": "#fffffe",
            "color": "#0c0800"
        },
        "horizontal": {
            "margin": "1rem 0",
            "padding": "0",
            "content": {
                "padding": "0 0.5rem"
            }
        },
        "vertical": {
            "margin": "0 1rem",
            "padding": "0",
            "content": {
                "padding": "0.5rem 0"
            }
        }
    },
    "fieldset": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "padding": "1.125rem 1.125rem 1.125rem 1.125rem",
        "legend": {
            "background": "#fffffe",
            "hover": {
                "background": "#faf9f7",
                "color": "#1e1b15"
            },
            "color": "#0c0800",
            "border": {
                "radius": "6px",
                "width": "1",
                "color": "rgba(0, 0, 0, 0)"
            },
            "padding": "0.5rem 0.75rem",
            "gap": "0.5rem",
            "font": {
                "weight": "600"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "style": "solid",
                    "color": "#1e1b15",
                    "offset": "2",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        },
        "toggle": {
            "icon": {
                "color": "#686257",
                "hover": {
                    "color": "#686257"
                }
            }
        },
        "content": {
            "padding": "0"
        }
    },
    "splitter": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd"
        },
        "color": "#0c0800",
        "gutter": {
            "background": "#e4e2dd"
        },
        "handle": {
            "size": "24px",
            "background": "rgba(0, 0, 0, 0)",
            "border": {
                "radius": "6px"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "color": "#1e1b15",
                    "offset": "2",
                    "style": "solid",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        }
    },
    "toolbar": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "gap": "0.5rem",
        "padding": "0.75rem"
    },
    "confirmdialog": {
        "icon": {
            "size": "2rem",
            "color": "#0c0800"
        },
        "content": {
            "gap": "1rem"
        }
    },
    "confirmpopup": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "gutter": "10px",
        "arrow": {
            "offset": "1.25rem"
        },
        "content": {
            "padding": "0.75rem",
            "gap": "1rem"
        },
        "icon": {
            "size": "1.5rem",
            "color": "#0c0800"
        },
        "footer": {
            "gap": "0.5rem",
            "padding": "0 0.75rem 0.75rem 0.75rem"
        },
        "shadow": {
            "1": {
                "x": "0",
                "y": "4",
                "blur": "6",
                "spread": "-1",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            },
            "2": {
                "x": "0",
                "y": "2",
                "blur": "4",
                "spread": "-2",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            }
        }
    },
    "dialog": {
        "background": "#fffffe",
        "color": "#0c0800",
        "border": {
            "color": "#e4e2dd",
            "radius": "12px"
        },
        "header": {
            "padding": "1.25rem",
            "gap": "0.5rem"
        },
        "title": {
            "font": {
                "size": "1.25rem",
                "weight": "600"
            }
        },
        "content": {
            "padding": "0 1.25rem 1.25rem 1.25rem"
        },
        "footer": {
            "padding": "0 1.25rem 1.25rem 1.25rem",
            "gap": "0.5rem"
        },
        "shadow": {
            "1": {
                "x": "0",
                "y": "20",
                "blur": "25",
                "spread": "-5",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            },
            "2": {
                "x": "0",
                "y": "8",
                "blur": "10",
                "spread": "-6",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            }
        }
    },
    "contextmenu": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "list": {
            "padding": "0.25rem 0.25rem",
            "gap": "2px"
        },
        "item": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "active": {
                "background": "#fffbe6",
                "color": "#1e1b15"
            },
            "color": "#0c0800",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "gap": "0.5rem",
            "icon": {
                "color": "#0c0800",
                "focus": {
                    "color": "#0c0800"
                },
                "active": {
                    "color": "#0c0800"
                }
            }
        },
        "submenu": {
            "icon": {
                "size": "0.875rem",
                "color": "#b6b2aa",
                "focus": {
                    "color": "#99948a"
                },
                "active": {
                    "color": "#99948a"
                }
            },
            "mobile": {
                "indent": "1rem"
            }
        },
        "separator": {
            "border": {
                "color": "#e4e2dd"
            }
        },
        "shadow": {
            "1": {
                "x": "0",
                "y": "4",
                "blur": "6",
                "spread": "-1",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            },
            "2": {
                "x": "0",
                "y": "2",
                "blur": "4",
                "spread": "-2",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            }
        }
    },
    "dock": {
        "background": "rgba(255, 255, 255, 0.1)",
        "border": {
            "color": "rgba(255, 255, 255, 0.2)",
            "radius": "12px"
        },
        "padding": "0.5rem",
        "item": {
            "border": {
                "radius": "6px"
            },
            "padding": "0.5rem",
            "size": "3rem",
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "2",
                    "style": "solid",
                    "color": "#1e1b15",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        }
    },
    "megamenu": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "gap": "0.5rem",
        "vertical": {
            "orientation": {
                "padding": "0.25rem 0.25rem",
                "gap": "2px"
            }
        },
        "horizontal": {
            "orientation": {
                "padding": "0.5rem 0.75rem",
                "gap": "0.5rem"
            }
        },
        "base": {
            "item": {
                "border": {
                    "radius": "6px"
                },
                "padding": "0.5rem 0.75rem"
            }
        },
        "item": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "active": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "color": "#0c0800",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "gap": "0.5rem",
            "icon": {
                "color": "#0c0800",
                "focus": {
                    "color": "#0c0800"
                },
                "active": {
                    "color": "#0c0800"
                }
            }
        },
        "overlay": {
            "padding": "0",
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "radius": "6px"
            },
            "color": "#0c0800",
            "gap": "0.5rem",
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "submenu": {
            "label": {
                "padding": "0.5rem 0.75rem",
                "font": {
                    "weight": "600"
                },
                "background": "rgba(0, 0, 0, 0)",
                "color": "#686257"
            },
            "icon": {
                "size": "0.875rem",
                "color": "#b6b2aa",
                "focus": {
                    "color": "#99948a"
                },
                "active": {
                    "color": "#99948a"
                }
            },
            "padding": "0.25rem 0.25rem",
            "gap": "2px"
        },
        "separator": {
            "border": {
                "color": "#e4e2dd"
            }
        },
        "mobile": {
            "button": {
                "border": {
                    "radius": "0.875rem"
                },
                "size": "1.75rem",
                "color": "#686257",
                "hover": {
                    "color": "#686257",
                    "background": "#faf9f7"
                },
                "focus": {
                    "ring": {
                        "width": "1",
                        "offset": "2",
                        "style": "solid",
                        "color": "#1e1b15",
                        "shadow": {
                            "x": "0",
                            "y": "0",
                            "blur": "0",
                            "spread": "0",
                            "color": "rgba(0, 0, 0, 0)",
                            "type": "dropShadow"
                        }
                    }
                }
            }
        }
    },
    "menu": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "list": {
            "padding": "0.25rem 0.25rem",
            "gap": "2px"
        },
        "item": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "color": "#0c0800",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "gap": "0.5rem",
            "icon": {
                "color": "#0c0800",
                "focus": {
                    "color": "#0c0800"
                }
            }
        },
        "submenu": {
            "label": {
                "padding": "0.5rem 0.75rem",
                "font": {
                    "weight": "600"
                },
                "background": "rgba(0, 0, 0, 0)",
                "color": "#686257"
            }
        },
        "separator": {
            "border": {
                "color": "#e4e2dd"
            }
        },
        "shadow": {
            "1": {
                "x": "0",
                "y": "4",
                "blur": "6",
                "spread": "-1",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            },
            "2": {
                "x": "0",
                "y": "2",
                "blur": "4",
                "spread": "-2",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            }
        }
    },
    "menubar": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "gap": "0.5rem",
        "padding": "0.5rem 0.75rem",
        "base": {
            "item": {
                "border": {
                    "radius": "6px"
                },
                "padding": "0.5rem 0.75rem"
            }
        },
        "item": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "active": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "color": "#0c0800",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "gap": "0.5rem",
            "icon": {
                "color": "#0c0800",
                "focus": {
                    "color": "#0c0800"
                },
                "active": {
                    "color": "#0c0800"
                }
            }
        },
        "submenu": {
            "padding": "0.25rem 0.25rem",
            "gap": "2px",
            "background": "#fffffe",
            "border": {
                "color": "#e4e2dd",
                "radius": "6px"
            },
            "mobile": {
                "indent": "1rem"
            },
            "icon": {
                "size": "0.875rem",
                "color": "#b6b2aa",
                "focus": {
                    "color": "#99948a"
                },
                "active": {
                    "color": "#99948a"
                }
            },
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "4",
                    "blur": "6",
                    "spread": "-1",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "4",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.1)",
                    "type": "dropShadow"
                }
            }
        },
        "separator": {
            "border": {
                "color": "#e4e2dd"
            }
        },
        "mobile": {
            "button": {
                "border": {
                    "radius": "0.875rem"
                },
                "size": "1.75rem",
                "color": "#686257",
                "hover": {
                    "color": "#686257",
                    "background": "#faf9f7"
                },
                "focus": {
                    "ring": {
                        "width": "1",
                        "offset": "2",
                        "style": "solid",
                        "color": "#1e1b15",
                        "shadow": {
                            "x": "0",
                            "y": "0",
                            "blur": "0",
                            "spread": "0",
                            "color": "rgba(0, 0, 0, 0)",
                            "type": "dropShadow"
                        }
                    }
                }
            }
        }
    },
    "panelmenu": {
        "gap": "0.5rem",
        "panel": {
            "background": "#fffffe",
            "border": {
                "color": "rgba(0, 0, 0, 0)",
                "width": "1px",
                "radius": "6px"
            },
            "color": "#0c0800",
            "padding": "0.25rem 0.25rem",
            "first": {
                "border": {
                    "width": "1px"
                },
                "top": {
                    "border": {
                        "radius": "6px"
                    }
                }
            },
            "last": {
                "border": {
                    "width": "1px"
                },
                "bottom": {
                    "border": {
                        "radius": "6px"
                    }
                }
            }
        },
        "item": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "color": "#0c0800",
            "gap": "0.5rem",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "6px"
            },
            "icon": {
                "color": "#0c0800",
                "focus": {
                    "color": "#0c0800"
                }
            },
            "active": {
                "shadow": {
                    "1": {
                        "x": "0",
                        "y": "3",
                        "blur": "8",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0.05)",
                        "type": "dropShadow"
                    },
                    "2": {
                        "x": "0",
                        "y": "0",
                        "blur": "1",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0.2)",
                        "type": "dropShadow"
                    }
                }
            }
        },
        "submenu": {
            "indent": "1rem",
            "icon": {
                "color": "#b6b2aa",
                "focus": {
                    "color": "#99948a"
                }
            }
        }
    },
    "tieredmenu": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "list": {
            "padding": "0.25rem 0.25rem",
            "gap": "2px"
        },
        "item": {
            "focus": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "active": {
                "background": "#f4f2ee",
                "color": "#1e1b15"
            },
            "color": "#0c0800",
            "padding": "0.5rem 0.75rem",
            "border": {
                "radius": "4px"
            },
            "gap": "0.5rem",
            "icon": {
                "color": "#0c0800",
                "focus": {
                    "color": "#0c0800"
                },
                "active": {
                    "color": "#0c0800"
                }
            }
        },
        "submenu": {
            "icon": {
                "size": "0.875rem",
                "color": "#b6b2aa",
                "focus": {
                    "color": "#99948a"
                },
                "active": {
                    "color": "#99948a"
                }
            },
            "mobile": {
                "indent": "1rem"
            }
        },
        "separator": {
            "border": {
                "color": "#e4e2dd"
            }
        },
        "shadow": {
            "1": {
                "x": "0",
                "y": "4",
                "blur": "6",
                "spread": "-1",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            },
            "2": {
                "x": "0",
                "y": "2",
                "blur": "4",
                "spread": "-2",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            }
        }
    },
    "orderlist": {
        "gap": "1.125rem",
        "controls": {
            "gap": "0.5rem"
        }
    },
    "organizationchart": {
        "gutter": "0.75rem",
        "node": {
            "background": "#fffffe",
            "hover": {
                "background": "#faf9f7",
                "color": "#1e1b15"
            },
            "selected": {
                "background": "#faf9f7",
                "color": "#686257"
            },
            "border": {
                "color": "#e4e2dd",
                "radius": "6px"
            },
            "color": "#0c0800",
            "padding": "0.75rem 1rem",
            "toggleable": {
                "padding": "0.75rem 1rem 1.25rem 1rem"
            },
            "toggle": {
                "button": {
                    "background": "#fffffe",
                    "hover": {
                        "background": "#faf9f7",
                        "color": "#0c0800"
                    },
                    "border": {
                        "color": "#e4e2dd",
                        "radius": "0.75rem"
                    },
                    "color": "#686257",
                    "size": "1.5rem",
                    "focus": {
                        "ring": {
                            "width": "1",
                            "offset": "2",
                            "color": "#1e1b15",
                            "style": "solid",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            }
        },
        "connector": {
            "color": "#e4e2dd",
            "border": {
                "radius": "6px"
            },
            "height": "24px"
        }
    },
    "paginator": {
        "padding": "0.5rem 1rem",
        "gap": "0.25rem",
        "border": {
            "radius": "6px"
        },
        "background": "#fffffe",
        "color": "#0c0800",
        "nav": {
            "button": {
                "background": "rgba(0, 0, 0, 0)",
                "hover": {
                    "background": "#faf9f7",
                    "color": "#686257"
                },
                "selected": {
                    "background": "#faf9f7",
                    "color": "#686257"
                },
                "width": "2.5rem",
                "height": "2.5rem",
                "border": {
                    "radius": "1.25rem"
                },
                "focus": {
                    "ring": {
                        "width": "1",
                        "offset": "2",
                        "style": "solid",
                        "color": "#1e1b15",
                        "shadow": {
                            "x": "0",
                            "y": "0",
                            "blur": "0",
                            "spread": "0",
                            "color": "rgba(0, 0, 0, 0)",
                            "type": "dropShadow"
                        }
                    }
                },
                "color": "#686257"
            }
        },
        "current": {
            "page": {
                "report": {
                    "color": "#686257"
                }
            }
        },
        "jump": {
            "to": {
                "page": {
                    "input": {
                        "max": {
                            "width": "2.5rem"
                        }
                    }
                }
            }
        }
    },
    "picklist": {
        "gap": "1.125rem",
        "controls": {
            "gap": "0.5rem"
        }
    },
    "timeline": {
        "event": {
            "min": {
                "height": "5rem"
            },
            "marker": {
                "size": "1.125rem",
                "border": {
                    "radius": "0.5625rem",
                    "width": "2px",
                    "color": "#e4e2dd"
                },
                "background": "#fffffe",
                "content": {
                    "border": {
                        "radius": "0.1875rem"
                    },
                    "size": "0.375rem",
                    "background": "#1e1b15",
                    "inset": {
                        "shadow": {
                            "1": {
                                "x": "0",
                                "y": "0.5",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0.06)",
                                "type": "dropShadow"
                            },
                            "2": {
                                "x": "0",
                                "y": "1",
                                "blur": "1",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0.12)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            },
            "connector": {
                "color": "#e4e2dd",
                "size": "2px"
            }
        },
        "horizontal": {
            "event": {
                "content": {
                    "padding": "1rem 0"
                }
            }
        },
        "vertical": {
            "event": {
                "content": {
                    "padding": "0 1rem"
                }
            }
        }
    },
    "tree": {
        "background": "rgba(0, 0, 0, 0)",
        "color": "#0c0800",
        "padding": "0rem",
        "gap": "2px",
        "indent": "1rem",
        "node": {
            "padding": "0.5rem 0.5rem",
            "border": {
                "radius": "6px"
            },
            "hover": {
                "background": "#faf9f7",
                "color": "#0c0800"
            },
            "selected": {
                "background": "#fffffe",
                "color": "#0c0800",
                "shadow": {
                    "1": {
                        "x": "0",
                        "y": "3",
                        "blur": "8",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0.05)",
                        "type": "dropShadow"
                    },
                    "2": {
                        "x": "0",
                        "y": "0",
                        "blur": "1",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0.2)",
                        "type": "dropShadow"
                    }
                }
            },
            "color": "#0c0800",
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "-1px",
                    "style": "solid",
                    "color": "#1e1b15",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            },
            "gap": "0.4rem",
            "icon": {
                "color": "#1e1b15",
                "hover": {
                    "color": "#0c0800"
                },
                "selected": {
                    "color": "#0c0800"
                }
            },
            "toggle": {
                "button": {
                    "border": {
                        "radius": "0.875rem"
                    },
                    "size": "1.75rem",
                    "hover": {
                        "background": "#faf9f7",
                        "color": "#686257"
                    },
                    "selected": {
                        "hover": {
                            "background": "#fffffe",
                            "color": "#1e1b15"
                        }
                    },
                    "color": "#686257",
                    "focus": {
                        "ring": {
                            "width": "1",
                            "offset": "2",
                            "style": "solid",
                            "color": "#1e1b15",
                            "shadow": {
                                "x": "0",
                                "y": "0",
                                "blur": "0",
                                "spread": "0",
                                "color": "rgba(0, 0, 0, 0)",
                                "type": "dropShadow"
                            }
                        }
                    }
                }
            }
        },
        "loading": {
            "icon": {
                "size": "2rem"
            }
        },
        "filter": {
            "margin": "0.5rem"
        }
    },
    "virtualscroller": {
        "loader": {
            "mask": {
                "background": "#fffffe",
                "color": "#686257"
            },
            "icon": {
                "size": "2rem"
            }
        }
    },
    "image": {
        "preview": {
            "icon": {
                "size": "1.5rem"
            },
            "mask": {
                "background": "rgba(0, 0, 0, 0.4)",
                "color": "#e4e2dd"
            }
        },
        "toolbar": {
            "background": "rgba(255, 255, 255, 0.1)",
            "border": {
                "color": "rgba(255, 255, 255, 0.2)",
                "width": "1px",
                "radius": "30px"
            },
            "padding": "0.5rem",
            "gap": "0.5rem",
            "position": {
                "right": "1rem",
                "top": "1rem"
            }
        },
        "action": {
            "hover": {
                "background": "rgba(255, 255, 255, 0.1)",
                "color": "#fffffe"
            },
            "color": "#faf9f7",
            "size": "3rem",
            "icon": {
                "size": "1.5rem"
            },
            "border": {
                "radius": "1.5rem"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "2",
                    "style": "solid",
                    "color": "#1e1b15",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        }
    },
    "popover": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "gutter": "10px",
        "arrow": {
            "offset": "1.25rem"
        },
        "content": {
            "padding": "0.75rem"
        },
        "shadow": {
            "1": {
                "x": "0",
                "y": "4",
                "blur": "6",
                "spread": "-1",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            },
            "2": {
                "x": "0",
                "y": "2",
                "blur": "4",
                "spread": "-2",
                "color": "rgba(0, 0, 0, 0.1)",
                "type": "dropShadow"
            }
        }
    },
    "fileupload": {
        "background": "#fffffe",
        "border": {
            "color": "#e4e2dd",
            "radius": "6px"
        },
        "color": "#0c0800",
        "header": {
            "background": "rgba(0, 0, 0, 0)",
            "color": "#0c0800",
            "padding": "1.125rem",
            "border": {
                "width": "0",
                "radius": "0"
            },
            "gap": "0.5rem"
        },
        "content": {
            "highlight": {
                "border": {
                    "color": "#1e1b15"
                }
            },
            "padding": "0 1.125rem 1.125rem 1.125rem",
            "gap": "1rem"
        },
        "file": {
            "padding": "1rem",
            "gap": "1rem",
            "border": {
                "color": "#e4e2dd"
            },
            "info": {
                "gap": "0.5rem"
            },
            "list": {
                "gap": "0.5rem"
            }
        },
        "progressbar": {
            "height": "0.25rem"
        },
        "basic": {
            "gap": "0.5rem"
        }
    },
    "speeddial": {
        "gap": "0.5rem"
    },
    "splitbutton": {
        "border": {
            "radius": "6px"
        },
        "rounded": {
            "border": {
                "radius": "2rem"
            }
        },
        "raised": {
            "shadow": {
                "1": {
                    "x": "0",
                    "y": "3",
                    "blur": "1",
                    "spread": "-2",
                    "color": "rgba(0, 0, 0, 0.2)",
                    "type": "dropShadow"
                },
                "2": {
                    "x": "0",
                    "y": "2",
                    "blur": "2",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0.14)",
                    "type": "dropShadow"
                },
                "3": {
                    "x": "0",
                    "y": "1",
                    "blur": "5",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0.12)",
                    "type": "innerShadow"
                }
            }
        }
    },
    "stepper": {
        "separator": {
            "background": "#e4e2dd",
            "active": {
                "background": "#1e1b15"
            },
            "margin": "0 0 0 1rem",
            "size": "2px"
        },
        "step": {
            "padding": "0.5rem",
            "gap": "1rem",
            "header": {
                "padding": "0",
                "border": {
                    "radius": "6px"
                },
                "focus": {
                    "ring": {
                        "width": "1",
                        "style": "solid",
                        "color": "#1e1b15",
                        "offset": "2",
                        "shadow": {
                            "x": "0",
                            "y": "0",
                            "blur": "0",
                            "spread": "0",
                            "color": "rgba(0, 0, 0, 0)",
                            "type": "dropShadow"
                        }
                    }
                },
                "gap": "0.5rem"
            },
            "title": {
                "color": "#686257",
                "active": {
                    "color": "#1e1b15"
                },
                "font": {
                    "weight": "500"
                }
            },
            "number": {
                "background": "#fffffe",
                "active": {
                    "background": "#fffffe",
                    "border": {
                        "color": "#e4e2dd"
                    },
                    "color": "#1e1b15"
                },
                "border": {
                    "color": "#e4e2dd",
                    "radius": "1rem"
                },
                "color": "#686257",
                "size": "2rem",
                "font": {
                    "size": "1.143rem",
                    "weight": "500"
                },
                "shadow": {
                    "1": {
                        "x": "0",
                        "y": "0.5",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0.06)",
                        "type": "dropShadow"
                    },
                    "2": {
                        "x": "0",
                        "y": "1",
                        "blur": "1",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0.12)",
                        "type": "dropShadow"
                    }
                }
            }
        },
        "steppanels": {
            "padding": "0.875rem 0.5rem 1.125rem 0.5rem"
        },
        "steppanel": {
            "padding": "0 0 0 1rem",
            "background": "#fffffe",
            "color": "#0c0800"
        }
    },
    "blockui": {
        "border": {
            "radius": "6px"
        }
    },
    "inplace": {
        "padding": "0.5rem 0.75rem",
        "border": {
            "radius": "6px"
        },
        "focus": {
            "ring": {
                "width": "1",
                "offset": "2",
                "style": "solid",
                "color": "#1e1b15",
                "shadow": {
                    "x": "0",
                    "y": "0",
                    "blur": "0",
                    "spread": "0",
                    "color": "rgba(0, 0, 0, 0)",
                    "type": "dropShadow"
                }
            }
        },
        "display": {
            "hover": {
                "background": "#faf9f7",
                "color": "#1e1b15"
            }
        }
    },
    "metergroup": {
        "gap": "1rem",
        "meters": {
            "background": "#e4e2dd",
            "size": "0.5rem"
        },
        "label": {
            "gap": "0.5rem",
            "marker": {
                "size": "0.5rem"
            },
            "icon": {
                "size": "1rem"
            },
            "list": {
                "vertical": {
                    "gap": "0.5rem"
                },
                "horizontal": {
                    "gap": "1rem"
                }
            }
        },
        "border": {
            "radius": "6px"
        }
    },
    "terminal": {
        "background": "#fffffe",
        "border": {
            "color": "#f4f2ee",
            "radius": "6px"
        },
        "color": "#1e1b15",
        "height": "18rem",
        "prompt": {
            "gap": "0.25rem"
        },
        "command": {
            "response": {
                "margin": "2px 0"
            }
        },
        "padding": "0.5rem 0.75rem"
    },
    "imagecompare": {
        "handle": {
            "size": "15px",
            "hover": {
                "size": "30px",
                "background": "rgba(255, 255, 255, 0.3)",
                "border": {
                    "color": "rgba(0, 0, 0, 0)"
                }
            },
            "background": "rgba(255, 255, 255, 0.3)",
            "border": {
                "color": "rgba(0, 0, 0, 0)",
                "width": "0",
                "radius": "7.5px"
            },
            "focus": {
                "ring": {
                    "width": "1",
                    "offset": "2",
                    "style": "solid",
                    "color": "rgba(255, 255, 255, 0.3)",
                    "shadow": {
                        "x": "0",
                        "y": "0",
                        "blur": "0",
                        "spread": "0",
                        "color": "rgba(0, 0, 0, 0)",
                        "type": "dropShadow"
                    }
                }
            }
        }
    },
    "overlaybadge": {
        "outline": {
            "color": "#fffffe",
            "width": "2px"
        }
    },
    "inputotp": {
        "input": {
            "width": "2.5rem",
            "sm": {
                "width": "2rem"
            },
            "lg": {
                "width": "3rem"
            }
        },
        "gap": "0.5rem"
    },
    "anchor": {
        "gutter": "2px"
    },
    "icon": {
        "size": "1rem"
    },
    "disabled": {
        "opacity": "0.6"
    },
    "focus": {
        "ring": {
            "width": "1",
            "color": "#1e1b15",
            "offset": "2",
            "style": "solid",
            "shadow": {
                "x": "0",
                "y": "0",
                "blur": "0",
                "spread": "0",
                "color": "rgba(0, 0, 0, 0)",
                "type": "dropShadow"
            },
            "stroke": {
                "color": "#1e1b15",
                "width": "3px",
                "style": "solid"
            }
        }
    },
    "radius": {
        "none": "0",
        "xs": "2px",
        "sm": "4px",
        "md": "6px",
        "lg": "8px",
        "xl": "12px"
    },
    "padding": {
        "none": "0",
        "xxs": "2px",
        "xs": "4px",
        "sm": "8px",
        "md": "12px",
        "lg": "16px",
        "xl": "20px",
        "xxl": "24px"
    },
    "Surface": {
        "Ochre": {
            "ochrePrimary": "#dfc725",
            "onOchrePrimary": "#201c00",
            "ochreDim": "#6b5f00",
            "onOchreDim": "#ffffff",
            "ochreBright": "#fff2b0",
            "onOchreBright": "#201c00"
        },
        "Petrel": {
            "petrelPrimary": "#1e9bd0",
            "onPetrelPrimary": "#ffffff",
            "petrelDim": "#00658b",
            "onPetrelDim": "#ffffff",
            "petrelBright": "#c5e7ff",
            "onPetrelBright": "#001e2d"
        },
        "Candy": {
            "candyPrimary": "#e68cd9",
            "onCandyPrimary": "#380037",
            "candyDim": "#8f4087",
            "onCandyDim": "#ffffff",
            "candyBright": "#ffd7f4",
            "onCandyBright": "#380037"
        },
        "Coral": {
            "coralPrimary": "#fc546f",
            "onCoralPrimary": "#ffffff",
            "coralDim": "#91002c",
            "onCoralDim": "#ffffff",
            "coralBright": "#ffb2b8",
            "onCoralBright": "#40000e"
        },
        "Scarlet": {
            "scarletPrimary": "#900b13",
            "onScarletPrimary": "#ffffff",
            "scarletDim": "#410003",
            "onScarletDim": "#ffffff",
            "scarletBright": "#ffb4ac",
            "onScarletBright": "#410003"
        },
        "Ground": {
            "main": "#f4f2ee",
            "temp": "#fefefb"
        },
        "Container": {
            "main": "#fffffe",
            "sub": "#faf9f7"
        },
        "Overlay": {
            "main": "rgba(255, 255, 255, 0.9)",
            "sub": "rgba(250, 249, 247, 0.9)"
        },
        "Element": {
            "main": "#fffffe",
            "sub": "#f4f2ee",
            "placeholder": "#faf9f7"
        },
        "Border": {
            "main": "#e4e2dd",
            "sub": "#f4f2ee",
            "placeholder": "#faf9f7"
        },
        "Text": {
            "main": "#0c0800",
            "sub": "#1e1b15",
            "placeholder": "#686257"
        }
    },
    "Chart": {
        "ochre": {
            "1": "#9c8214",
            "2": "#c58108",
            "3": "#c66e13",
            "4": "#c99b0b",
            "5": "#ecb518",
            "6": "#e5c236",
            "7": "#ebcb12",
            "8": "#d2d40c",
            "9": "#f1f219"
        },
        "candy": {
            "1": "#da378b",
            "2": "#ebb5ca",
            "3": "#e780f2",
            "4": "#ef6ea1",
            "5": "#c7bef4",
            "6": "#d46bf3",
            "7": "#f289cf",
            "8": "#bb88e9",
            "9": "#f360bc"
        },
        "petrel": {
            "1": "#0edbd6",
            "2": "#0263c3",
            "3": "#1c96ff",
            "4": "#59b8e8",
            "5": "#a4ccf9",
            "6": "#0e4f65",
            "7": "#50d3e6",
            "8": "#004287",
            "9": "#05bcf4"
        },
        "coral": {
            "1": "#ff7889",
            "2": "#cb6e75",
            "3": "#ff8942",
            "4": "#f9bcef",
            "5": "#ea3c95",
            "6": "#fc7f5f",
            "7": "#d46f8e",
            "8": "#edb7b9",
            "9": "#fc534d"
        },
        "scarlet": {
            "1": "#be0808",
            "2": "#82063a",
            "3": "#a63f7a",
            "4": "#8c4326",
            "5": "#b55c62",
            "6": "#ac3a54",
            "7": "#853933",
            "8": "#a93813",
            "9": "#612204"
        },
        "core": {
            "1": "#9681ff",
            "2": "#009d9a",
            "3": "#fa4d56",
            "4": "#00428c",
            "5": "#b28600",
            "6": "#1192e8",
            "7": "#82900c",
            "8": "#6929c4",
            "9": "#c66e13",
            "10": "#005d5d",
            "11": "#870e64",
            "12": "#8a3800",
            "13": "#214100",
            "14": "#8c0610"
        }
    },
    "Ideally-Core": {
        "ochre": {
            "10": "#201c00",
            "20": "#383000",
            "30": "#514700",
            "40": "#6b5f00",
            "50": "#877700",
            "60": "#a49100",
            "70": "#c1ac00",
            "80": "#dfc725",
            "90": "#f6e47e",
            "95": "#fff2b0",
            "98": "#fff9eb",
            "100": "#ffffff",
            "00": "#000000"
        },
        "candy": {
            "10": "#380037",
            "20": "#580c55",
            "30": "#73276d",
            "40": "#8f4087",
            "50": "#ab59a1",
            "60": "#c972bd",
            "70": "#e68cd9",
            "80": "#ffabf0",
            "90": "#ffd7f4",
            "95": "#ffebf7",
            "98": "#fff7f9",
            "100": "#ffffff",
            "00": "#000000"
        },
        "petrel": {
            "10": "#001e2d",
            "20": "#00344a",
            "30": "#004c6a",
            "40": "#00658b",
            "50": "#0080af",
            "60": "#1e9bd0",
            "70": "#48b6ec",
            "80": "#7fd0ff",
            "90": "#c5e7ff",
            "95": "#e4f3ff",
            "98": "#f5faff",
            "100": "#ffffff",
            "00": "#000000"
        },
        "scarlet": {
            "10": "#410003",
            "20": "#680007",
            "30": "#900b13",
            "40": "#b32927",
            "50": "#d5423c",
            "60": "#f85b53",
            "70": "#ff897f",
            "80": "#ffb4ac",
            "90": "#ffdad6",
            "95": "#ffedeb",
            "98": "#fff8f7",
            "100": "#ffffff",
            "00": "#000000"
        },
        "coral": {
            "10": "#40000e",
            "20": "#67001d",
            "30": "#91002c",
            "40": "#b61d40",
            "50": "#d93957",
            "60": "#fc546f",
            "70": "#ff8794",
            "80": "#ffb2b8",
            "90": "#ffdadb",
            "95": "#ffeced",
            "98": "#fff8f7",
            "100": "#ffffff",
            "00": "#000000"
        },
        "graphite": {
            "10": "#1e1b15",
            "20": "#312d25",
            "30": "#474238",
            "40": "#686257",
            "50": "#868074",
            "60": "#99948a",
            "70": "#b6b2aa",
            "80": "#cfccc5",
            "90": "#e4e2dd",
            "95": "#f4f2ee",
            "98": "#faf9f7",
            "100": "#fffffe",
            "00": "#0c0800"
        }
    },
    "Primitive-Core": {
        "emerald": {
            "50": "#ecfdf5",
            "100": "#d1fae5",
            "200": "#a7f3d0",
            "300": "#6ee7b7",
            "400": "#34d399",
            "500": "#10b981",
            "600": "#059669",
            "700": "#047857",
            "800": "#065f46",
            "900": "#064e3b",
            "950": "#022c22"
        },
        "green": {
            "50": "#f0fdf4",
            "100": "#dcfce7",
            "200": "#bbf7d0",
            "300": "#86efac",
            "400": "#4ade80",
            "500": "#22c55e",
            "600": "#16a34a",
            "700": "#15803d",
            "800": "#166534",
            "900": "#14532d",
            "950": "#052e16"
        },
        "lime": {
            "50": "#f7fee7",
            "100": "#ecfccb",
            "200": "#d9f99d",
            "300": "#bef264",
            "400": "#a3e635",
            "500": "#84cc16",
            "600": "#65a30d",
            "700": "#4d7c0f",
            "800": "#3f6212",
            "900": "#365314",
            "950": "#1a2e05"
        },
        "red": {
            "50": "#fef2f2",
            "100": "#fee2e2",
            "200": "#fecaca",
            "300": "#fca5a5",
            "400": "#f87171",
            "500": "#ef4444",
            "600": "#dc2626",
            "700": "#b91c1c",
            "800": "#991b1b",
            "900": "#7f1d1d",
            "950": "#450a0a"
        },
        "orange": {
            "50": "#fff7ed",
            "100": "#ffedd5",
            "200": "#fed7aa",
            "300": "#fdba74",
            "400": "#fb923c",
            "500": "#f97316",
            "600": "#ea580c",
            "700": "#c2410c",
            "800": "#9a3412",
            "900": "#7c2d12",
            "950": "#431407"
        },
        "amber": {
            "50": "#fffbeb",
            "100": "#fef3c7",
            "200": "#fde68a",
            "300": "#fcd34d",
            "400": "#fbbf24",
            "500": "#f59e0b",
            "600": "#d97706",
            "700": "#b45309",
            "800": "#92400e",
            "900": "#78350f",
            "950": "#451a03"
        },
        "yellow": {
            "50": "#fefce8",
            "100": "#fef9c3",
            "200": "#fef08a",
            "300": "#fde047",
            "400": "#facc15",
            "500": "#eab308",
            "600": "#ca8a04",
            "700": "#a16207",
            "800": "#854d0e",
            "900": "#713f12",
            "950": "#422006"
        },
        "teal": {
            "50": "#f0fdfa",
            "100": "#ccfbf1",
            "200": "#99f6e4",
            "300": "#5eead4",
            "400": "#2dd4bf",
            "500": "#14b8a6",
            "600": "#0d9488",
            "700": "#0f766e",
            "800": "#115e59",
            "900": "#134e4a",
            "950": "#042f2e"
        },
        "cyan": {
            "50": "#ecfeff",
            "100": "#cffafe",
            "200": "#a5f3fc",
            "300": "#67e8f9",
            "400": "#22d3ee",
            "500": "#06b6d4",
            "600": "#0891b2",
            "700": "#0e7490",
            "800": "#155e75",
            "900": "#164e63",
            "950": "#083344"
        },
        "sky": {
            "50": "#f0f9ff",
            "100": "#e0f2fe",
            "200": "#bae6fd",
            "300": "#7dd3fc",
            "400": "#38bdf8",
            "500": "#0ea5e9",
            "600": "#0284c7",
            "700": "#0369a1",
            "800": "#075985",
            "900": "#0c4a6e",
            "950": "#082f49"
        },
        "blue": {
            "50": "#eff6ff",
            "100": "#dbeafe",
            "200": "#bfdbfe",
            "300": "#93c5fd",
            "400": "#60a5fa",
            "500": "#3b82f6",
            "600": "#2563eb",
            "700": "#1d4ed8",
            "800": "#1e40af",
            "900": "#1e3a8a",
            "950": "#172554"
        },
        "indigo": {
            "50": "#eef2ff",
            "100": "#e0e7ff",
            "200": "#c7d2fe",
            "300": "#a5b4fc",
            "400": "#818cf8",
            "500": "#6366f1",
            "600": "#4f46e5",
            "700": "#4338ca",
            "800": "#3730a3",
            "900": "#312e81",
            "950": "#1e1b4b"
        },
        "violet": {
            "50": "#f5f3ff",
            "100": "#ede9fe",
            "200": "#ddd6fe",
            "300": "#c4b5fd",
            "400": "#a78bfa",
            "500": "#8b5cf6",
            "600": "#7c3aed",
            "700": "#6d28d9",
            "800": "#5b21b6",
            "900": "#4c1d95",
            "950": "#2e1065"
        },
        "purple": {
            "50": "#faf5ff",
            "100": "#f3e8ff",
            "200": "#e9d5ff",
            "300": "#d8b4fe",
            "400": "#c084fc",
            "500": "#a855f7",
            "600": "#9333ea",
            "700": "#7e22ce",
            "800": "#6b21a8",
            "900": "#581c87",
            "950": "#3b0764"
        },
        "fuchsia": {
            "50": "#fdf4ff",
            "100": "#fae8ff",
            "200": "#f5d0fe",
            "300": "#f0abfc",
            "400": "#e879f9",
            "500": "#d946ef",
            "600": "#c026d3",
            "700": "#a21caf",
            "800": "#86198f",
            "900": "#701a75",
            "950": "#4a044e"
        },
        "pink": {
            "50": "#fdf2f8",
            "100": "#fce7f3",
            "200": "#fbcfe8",
            "300": "#f9a8d4",
            "400": "#f472b6",
            "500": "#ec4899",
            "600": "#db2777",
            "700": "#be185d",
            "800": "#9d174d",
            "900": "#831843",
            "950": "#500724"
        },
        "rose": {
            "50": "#fff1f2",
            "100": "#ffe4e6",
            "200": "#fecdd3",
            "300": "#fda4af",
            "400": "#fb7185",
            "500": "#f43f5e",
            "600": "#e11d48",
            "700": "#be123c",
            "800": "#9f1239",
            "900": "#881337",
            "950": "#4c0519"
        },
        "slate": {
            "50": "#f8fafc",
            "100": "#f1f5f9",
            "200": "#e2e8f0",
            "300": "#cbd5e1",
            "400": "#94a3b8",
            "500": "#64748b",
            "600": "#475569",
            "700": "#334155",
            "800": "#1e293b",
            "900": "#0f172a",
            "950": "#020617"
        },
        "gray": {
            "50": "#f9fafb",
            "100": "#f3f4f6",
            "200": "#e5e7eb",
            "300": "#d1d5db",
            "400": "#9ca3af",
            "500": "#6b7280",
            "600": "#4b5563",
            "700": "#374151",
            "800": "#1f2937",
            "900": "#111827",
            "950": "#030712"
        },
        "zinc": {
            "50": "#fafafa",
            "100": "#f4f4f5",
            "200": "#e4e4e7",
            "300": "#d4d4d8",
            "400": "#a1a1aa",
            "500": "#71717a",
            "600": "#52525b",
            "700": "#3f3f46",
            "800": "#27272a",
            "900": "#18181b",
            "950": "#09090b"
        },
        "neutral": {
            "50": "#fafafa",
            "100": "#f5f5f5",
            "200": "#e5e5e5",
            "300": "#d4d4d4",
            "400": "#a3a3a3",
            "500": "#737373",
            "600": "#525252",
            "700": "#404040",
            "800": "#262626",
            "900": "#171717",
            "950": "#0a0a0a"
        },
        "stone": {
            "50": "#fafaf9",
            "100": "#f5f5f4",
            "200": "#e7e5e4",
            "300": "#d6d3d1",
            "400": "#a8a29e",
            "500": "#78716c",
            "600": "#57534e",
            "700": "#44403c",
            "800": "#292524",
            "900": "#1c1917",
            "950": "#0c0a09"
        }
    },
    "fontFamily": {
        "Family": "Family",
        "Inter": "Inter",
        "Sohne": "Söhne",
        "Sohne-Mono": "Söhne Mono"
    },
    "fontSize": {
        "xxs": "11px",
        "xs": "12px",
        "sm": "14px",
        "md": "16px",
        "lg": "22px",
        "xl": "26px",
        "xxl": "30px",
        "jumbo": "45px"
    },
    "fontWeight": {
        "Family": {
            "Regular": "Regular"
        },
        "Inter": {
            "Regular": "Regular",
            "Medium": "Medium",
            "Bold": "Bold"
        },
        "Sohne-Mono": {
            "Buch": "Buch",
            "Kraftig": "Kräftig"
        },
        "Sohne": {
            "Buch": "Buch"
        }
    },
    "lineHeight": {
        "xs": "102%",
        "sm": "108%",
        "md": "116%",
        "lg": "128%",
        "xl": "150%"
    },
    "State": {
        "highlight": {
            "background": "#fffbe6",
            "color": "#201c00",
            "border": {
                "color": "#c1ac00"
            }
        },
        "hover": {
            "background": "#f4f2ee",
            "color": "#1e1b15",
            "border": {
                "color": "#cfccc5"
            }
        },
        "focus": {
            "background": "#e4e2dd",
            "color": "#1e1b15",
            "border": {
                "color": "#c1ac00"
            }
        }
    },
    "Title": {
        "HeadingDisplay": {
            "fontFamily": "Family",
            "fontWeight": "400",
            "fontSize": "45px",
            "lineHeight": 1.08
        },
        "HeadingCompact": {
            "fontFamily": "Family",
            "fontWeight": "400",
            "fontSize": "26px",
            "lineHeight": 1.08
        },
        "Screen": {
            "fontFamily": "Inter",
            "fontWeight": "500",
            "fontSize": "30px",
            "lineHeight": 1.16
        },
        "Section": {
            "fontFamily": "Inter",
            "fontWeight": "500",
            "fontSize": "26px",
            "lineHeight": 1.5
        },
        "Subsection": {
            "fontFamily": "Inter",
            "fontWeight": "500",
            "fontSize": "22px",
            "lineHeight": 1.5
        },
        "Group": {
            "fontFamily": "Inter",
            "fontWeight": "500",
            "fontSize": "14px",
            "lineHeight": 1.5
        },
        "Body": {
            "fontFamily": "Inter",
            "fontWeight": "500",
            "fontSize": "16px",
            "lineHeight": 1.5
        }
    },
    "Label": {
        "Axis": {
            "fontFamily": "Inter",
            "fontWeight": "400",
            "fontSize": "12px",
            "lineHeight": 1.02
        },
        "Content": {
            "fontFamily": "'Söhne Mono'",
            "fontWeight": "400",
            "fontSize": "11px",
            "lineHeight": 1.02
        },
        "Tooltip": {
            "fontFamily": "Inter",
            "fontWeight": "500",
            "fontSize": "12px",
            "lineHeight": 1.5
        }
    },
    "Body": {
        "Large": {
            "fontFamily": "Inter",
            "fontWeight": "400",
            "fontSize": "16px",
            "lineHeight": 1.5,
            "letterSpacing": "0.01em"
        },
        "Large-Bold": {
            "fontFamily": "Inter",
            "fontWeight": "500",
            "fontSize": "16px",
            "lineHeight": 1.5,
            "letterSpacing": "0.01em"
        },
        "Large-Heavy": {
            "fontFamily": "Inter",
            "fontWeight": "700",
            "fontSize": "16px",
            "lineHeight": 1.5,
            "letterSpacing": "0.01em"
        },
        "Small": {
            "fontFamily": "Inter",
            "fontWeight": "400",
            "fontSize": "14px",
            "lineHeight": 1.5,
            "letterSpacing": "0.01em"
        },
        "Small-Bold": {
            "fontFamily": "Inter",
            "fontWeight": "500",
            "fontSize": "14px",
            "lineHeight": 1.5,
            "letterSpacing": "0.01em"
        },
        "Small-Heavy": {
            "fontFamily": "Inter",
            "fontWeight": "700",
            "fontSize": "14px",
            "lineHeight": 1.5,
            "letterSpacing": "0.01em"
        }
    },
    "Link": {
        "Large": {
            "fontFamily": "Inter",
            "fontWeight": "500",
            "fontSize": "16px",
            "lineHeight": 1.5
        },
        "Default": {
            "fontFamily": "Inter",
            "fontWeight": "400",
            "fontSize": "16px",
            "lineHeight": 1.5
        }
    },
    "Shadow": {
        "container": {
            "x": "0",
            "y": "0",
            "blur": "2",
            "spread": "0",
            "color": "rgba(17, 17, 17, 0.15)",
            "type": "dropShadow"
        },
        "element": {
            "x": "0",
            "y": "0",
            "blur": "4",
            "spread": "0",
            "color": "rgba(0, 0, 0, 0.27)",
            "type": "innerShadow"
        }
    }
});
